import { defineComponent, toRefs, computed, ref, watch, getCurrentInstance, nextTick, onMounted, onBeforeMount, inject } from 'vue';
import axios from 'axios';
import { vMaska } from 'maska';

// Type used by all icon components
// 1rem = 16px
var IconSizes;
(function (IconSizes) {
  IconSizes["sm"] = "0.75rem";
  IconSizes["small"] = "0.75rem";
  IconSizes["md"] = "1rem";
  IconSizes["medium"] = "1rem";
  IconSizes["lg"] = "1.5rem";
  IconSizes["large"] = "1.5rem";
  IconSizes["xl"] = "2rem";
  IconSizes["x-large"] = "2rem";
})(IconSizes || (IconSizes = {}));
var LassoIconSizes;
(function (LassoIconSizes) {
  LassoIconSizes["sm"] = "75px";
  LassoIconSizes["small"] = "75px";
  LassoIconSizes["md"] = "100px";
  LassoIconSizes["medium"] = "100px";
  LassoIconSizes["lg"] = "150px";
  LassoIconSizes["large"] = "150px";
  LassoIconSizes["xl"] = "200px";
  LassoIconSizes["x-large"] = "200px";
})(LassoIconSizes || (LassoIconSizes = {}));

var script$z = defineComponent({
  name: 'LassoLogo',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'LassoLogo'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    }
  },
  setup: props => {
    // props
    const {
      size
    } = toRefs(props);
    // computed
    const width = computed(() => {
      return LassoIconSizes[size.value];
    });
    return {
      width
    };
  }
});

function normalizeComponent$1(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$z = script$z;

/* template */
var __vue_render__$z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 66.7 14.1"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 66.7 14.1",
      "xml:space": "preserve",
      "width": _vm.width,
      "aria-labelledby": _vm.name
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group_2",
      "transform": "translate(-440 -317.347)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard-Copy",
      "transform": "translate(440 317.347)"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "Fill-7-Copy-2",
      "d": "M4.8,8.8c0.3,0.9,0.9,1.6,1.6,2.2c0.7,0.6,1.6,1,2.5,1c0.6,0,1.1-0.3,1.5-0.8\n\t\t\tc0.3-0.3,0.5-0.8,0.4-1.2c-0.1-0.8-0.7-1.5-1.5-1.8C7.8,7.7,6.1,7.9,4.8,8.8z M1.3,13.8L1.3,13.8c-0.4,0-0.7-0.4-0.7-0.7\n\t\t\tc0.2-1.9,1.1-3.6,2.6-4.8C3,6.7,3.3,5,4.2,3.7c1.3-2,3.4-3.3,5.8-3.6c4.7-0.7,8.7,2.1,9.3,6.4c0.2,2-0.3,4-1.6,5.6\n\t\t\tc-0.8,1-2,1.6-3.3,1.7c-0.4,0-0.7-0.3-0.7-0.6c0-0.4,0.3-0.7,0.6-0.7c0.9,0,1.8-0.5,2.3-1.2c1-1.3,1.5-2.9,1.3-4.5\n\t\t\tc-0.6-4.1-4.5-5.8-7.8-5.3c-2,0.2-3.7,1.3-4.9,3c-0.6,0.9-0.9,2-0.8,3.1C6.2,6.5,8.2,6.3,10,7c1.2,0.5,2.1,1.6,2.2,2.9\n\t\t\tc0.1,0.8-0.2,1.6-0.7,2.2c-0.6,0.7-1.5,1.2-2.4,1.2c-1.3,0-2.6-0.4-3.5-1.3c-0.8-0.7-1.4-1.5-1.8-2.4c-1,0.9-1.6,2.2-1.7,3.5\n\t\t\tC2,13.6,1.7,13.8,1.3,13.8L1.3,13.8z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group_1",
      "transform": "translate(463.816 319.889)"
    }
  }, [_c('path', {
    staticClass: "st1",
    attrs: {
      "id": "Path_1",
      "d": "M1.5,7.8h3.9v0.8H0.7V0.2h0.8V7.8z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "id": "Path_2",
      "d": "M8.1,8.5H7.2l3.6-8.3h0.8l3.6,8.3h-0.9l-0.9-2.2H9L8.1,8.5z M9.3,5.6H13l-1.8-4.4L9.3,5.6z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "id": "Path_3",
      "d": "M21.9,1.5c-0.2-0.3-0.4-0.5-0.7-0.6c-0.3-0.2-0.7-0.2-1-0.2c-0.2,0-0.4,0-0.6,0.1\n\t\t\tC19.4,0.9,19.2,1,19,1.1c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.2-0.2,0.5-0.2,0.7c0,0.2,0,0.5,0.2,0.7c0.1,0.2,0.2,0.3,0.4,0.4\n\t\t\tc0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.2,0.7,0.2c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.5,0.2,0.8,0.4c0.2,0.2,0.4,0.4,0.6,0.7\n\t\t\tc0.2,0.3,0.2,0.7,0.2,1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.4,0.5-0.6,0.7c-0.3,0.2-0.6,0.3-0.9,0.4c-0.3,0.1-0.6,0.1-1,0.1\n\t\t\tc-0.3,0-0.5,0-0.8-0.1c-0.2,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.4-0.3-0.5-0.5L18.1,7c0.2,0.3,0.4,0.6,0.8,0.7\n\t\t\tC19.2,7.9,19.6,8,20,8c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.5c0.2-0.4,0.2-1,0-1.4\n\t\t\tc-0.1-0.2-0.3-0.4-0.5-0.5C21,5.1,20.8,5,20.6,4.9c-0.2-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.5-0.2-0.7-0.4\n\t\t\tc-0.2-0.2-0.4-0.4-0.5-0.7c-0.3-0.6-0.3-1.4,0-2c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4C19.6,0,19.9,0,20.2,0\n\t\t\tc0.5,0,1,0.1,1.4,0.3C22,0.5,22.3,0.7,22.6,1L21.9,1.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "id": "Path_4",
      "d": "M30,1.5c-0.2-0.3-0.4-0.5-0.7-0.6c-0.3-0.2-0.7-0.2-1-0.2c-0.2,0-0.4,0-0.6,0.1\n\t\t\tc-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.2-0.2,0.5-0.2,0.7c0,0.2,0,0.5,0.2,0.7c0.1,0.2,0.2,0.3,0.4,0.4\n\t\t\tc0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.2,0.7,0.2c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.4,0.4,0.6,0.7\n\t\t\tc0.2,0.3,0.2,0.7,0.2,1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.4,0.5-0.6,0.7c-0.3,0.2-0.6,0.3-0.9,0.4c-0.3,0.1-0.6,0.1-1,0.1\n\t\t\tc-0.3,0-0.5,0-0.8-0.1c-0.2-0.1-0.5-0.1-0.7-0.2c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.4-0.3-0.5-0.5L26.2,7\n\t\t\tc0.2,0.3,0.4,0.6,0.8,0.7C27.3,7.9,27.7,8,28.1,8c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.5\n\t\t\tc0.2-0.4,0.2-1,0-1.4c-0.1-0.2-0.3-0.4-0.5-0.5c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.5-0.2-0.8-0.3s-0.5-0.2-0.8-0.3\n\t\t\tc-0.3-0.1-0.5-0.3-0.7-0.4c-0.2-0.2-0.4-0.4-0.5-0.7c-0.3-0.6-0.3-1.4,0-2c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4\n\t\t\tC27.7,0,28,0,28.3,0c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.7,0.4,0.9,0.7L30,1.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "id": "Path_5",
      "d": "M42.2,4.4c0,0.6-0.1,1.2-0.3,1.8c-0.4,1-1.2,1.9-2.3,2.3c-1.1,0.4-2.3,0.4-3.4,0\n\t\t\tc-1-0.4-1.9-1.2-2.3-2.3c-0.4-1.1-0.4-2.4,0-3.5c0.4-1,1.2-1.9,2.3-2.3c1.1-0.4,2.3-0.4,3.4,0c1,0.4,1.9,1.2,2.3,2.3\n\t\t\tC42.1,3.2,42.2,3.8,42.2,4.4z M41.3,4.4c0-0.5-0.1-0.9-0.2-1.4c-0.1-0.4-0.4-0.8-0.7-1.2c-0.3-0.3-0.7-0.6-1.1-0.8\n\t\t\tc-0.9-0.4-2-0.4-2.9,0c-0.4,0.2-0.8,0.5-1.1,0.8C35,2.2,34.8,2.6,34.6,3c-0.3,0.9-0.3,1.9,0,2.8c0.1,0.4,0.4,0.8,0.7,1.2\n\t\t\tc0.3,0.3,0.7,0.6,1.1,0.8c0.9,0.4,2,0.4,2.9,0c0.4-0.2,0.8-0.5,1.1-0.8c0.3-0.3,0.5-0.7,0.7-1.2C41.2,5.3,41.3,4.9,41.3,4.4\n\t\t\tL41.3,4.4z"
    }
  })])])]);
};
var __vue_staticRenderFns__$z = [];

/* style */
const __vue_inject_styles__$z = function (inject) {
  if (!inject) return;
  inject("data-v-1e8dd3c0_0", {
    source: ".st0[data-v-1e8dd3c0]{fill-rule:evenodd;clip-rule:evenodd;fill:#ffbf00}.st1[data-v-1e8dd3c0]{fill:#fff}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$z = "data-v-1e8dd3c0";
/* module identifier */
const __vue_module_identifier__$z = undefined;
/* functional template */
const __vue_is_functional_template__$z = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, createInjector, undefined, undefined);

var script$y = defineComponent({
  name: 'Marketplace',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Marketplace'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$y = script$y;

/* template */
var __vue_render__$y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "svgicon",
    attrs: {
      "id": "Fill-7-Copy-2",
      "d": "M4,10.9c0.3,0.8,0.8,1.6,1.5,2.2C6.1,13.6,7,14,7.9,13.9c0.6,0,1.1-0.3,1.5-0.8c0.3-0.3,0.4-0.8,0.4-1.2c-0.1-0.8-0.7-1.5-1.4-1.8C6.9,9.6,5.2,10.1,4,10.9z M0.6,15.7L0.6,15.7c-0.4,0-0.7-0.4-0.6-0.7c0.2-1.8,1.1-3.5,2.5-4.6C2.2,8.8,2.6,7.2,3.4,5.9C4.7,4,6.7,2.7,9,2.4c4.5-0.6,8.3,2.1,8.9,6.2c0.2,1.9-0.3,3.9-1.5,5.4c-0.8,1-1.9,1.6-3.2,1.6c-0.4,0-0.7-0.3-0.7-0.6s0.3-0.7,0.6-0.7c0.9,0,1.7-0.5,2.3-1.2c1-1.2,1.4-2.8,1.2-4.4c-0.6-3.9-4.3-5.6-7.5-5.1C7.3,3.9,5.6,5,4.5,6.6c-0.6,0.9-0.8,1.9-0.8,3C5.2,8.8,7.2,8.3,9,9.1c1.2,0.5,2,1.6,2.2,2.8c0.1,0.8-0.2,1.6-0.7,2.2c-0.6,0.7-1.4,1.1-2.4,1.2c-1.2,0-2.5-0.4-3.4-1.2c-0.8-0.6-1.4-1.4-1.8-2.3c-0.9,0.9-1.5,2.1-1.7,3.4C1.3,15.4,1,15.7,0.6,15.7z"
    }
  })])]);
};
var __vue_staticRenderFns__$y = [];

/* style */
const __vue_inject_styles__$y = undefined;
/* scoped */
const __vue_scope_id__$y = undefined;
/* module identifier */
const __vue_module_identifier__$y = undefined;
/* functional template */
const __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

var script$x = defineComponent({
  name: 'SmartCrew',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'SmartCrew'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    }
  },
  setup: props => {
    // props
    const {
      size
    } = toRefs(props);
    // computed
    const width = computed(() => {
      return LassoIconSizes[size.value];
    });
    return {
      width
    };
  }
});

/* script */
const __vue_script__$x = script$x;

/* template */
var __vue_render__$x = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 206.6 31.7",
      "role": "presentation",
      "width": _vm.width,
      "aria-labelledby": _vm.name
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M51.4,22.6c-0.6,0.9-1.4,1.7-2.4,2.2c-1.1,0.6-2.4,0.8-3.9,0.8c-1.5,0-2.9-0.3-4.1-0.8\n      c-1.2-0.5-2.2-1.3-2.9-2.2c-0.7-1-1.1-2.1-1.2-3.4H40c0.8,0,1.4,0.5,1.7,1.2c0.2,0.4,0.4,0.7,0.7,1c0.6,0.6,1.4,0.9,2.4,0.9\n      c0.9,0,1.6-0.2,2.1-0.7c0.5-0.5,0.7-1.1,0.7-1.8c0-0.7-0.2-1.2-0.6-1.7c-0.4-0.4-0.9-0.8-1.5-1.1c-0.6-0.3-1.4-0.6-2.4-0.9\n      c-1.3-0.4-2.4-0.9-3.3-1.3c-0.9-0.4-1.6-1.1-2.2-1.9c-0.6-0.8-0.9-1.9-0.9-3.3c0-1.9,0.7-3.3,2-4.4c1.3-1.1,3.1-1.6,5.3-1.6\n      c2.3,0,4.1,0.5,5.5,1.6c1.4,1.1,2.1,2.6,2.3,4.4h-3.2c-0.8,0-1.5-0.5-1.9-1.2c-0.2-0.3-0.3-0.5-0.6-0.7C45.7,7.2,45,6.9,44,6.9\n      c-0.8,0-1.4,0.2-1.9,0.6c-0.5,0.4-0.7,1-0.7,1.8c0,0.6,0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.8,1.4,1c0.6,0.3,1.4,0.6,2.4,0.9\n      c1.4,0.5,2.5,0.9,3.4,1.4c0.9,0.4,1.6,1.1,2.2,1.9c0.6,0.9,0.9,2,0.9,3.4C52.3,20.6,52,21.6,51.4,22.6z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M80.8,10.2c1.2,1.3,1.8,3.1,1.8,5.4v9.8h-1.7c-1.4,0-2.6-1.2-2.6-2.6v-6.8c0-1.3-0.3-2.3-1-3\n      c-0.7-0.7-1.6-1.1-2.7-1.1c-1.2,0-2.2,0.4-2.9,1.1c-0.7,0.8-1.1,1.9-1.1,3.3v9H69c-1.4,0-2.6-1.2-2.6-2.6v-6.8c0-1.3-0.3-2.3-1-3\n      c-0.7-0.7-1.6-1.1-2.7-1.1c-1.2,0-2.2,0.4-2.9,1.1c-0.7,0.8-1.1,1.9-1.1,3.3v6c0,1.6-1.3,2.9-2.9,2.9h-1.4V8.5h1.9\n      c1.3,0,2.4,1.1,2.4,2.4v0.8c0.4-1.1,1.2-2,2.1-2.6c1-0.6,2.1-0.9,3.4-0.9c1.4,0,2.6,0.3,3.6,1c1,0.7,1.8,1.6,2.3,2.8\n      c0.5-1.2,1.3-2.1,2.4-2.8c1-0.7,2.2-1,3.5-1C78,8.3,79.6,8.9,80.8,10.2z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M95.6,9.3c1,0.7,1.7,1.6,2.2,2.7V8.5h2.4c1,0,1.9,0.8,1.9,1.9v13.2c0,1-0.8,1.8-1.8,1.8h-2.5v-3.5\n      c-0.4,1.1-1.2,2.1-2.2,2.7c-1,0.7-2.2,1-3.7,1c-1.4,0-2.7-0.3-3.8-1c-1.1-0.7-2-1.7-2.7-3s-1-2.9-1-4.6s0.3-3.3,1-4.6\n      c0.6-1.3,1.5-2.3,2.7-3c1.1-0.7,2.4-1,3.8-1C93.4,8.3,94.6,8.6,95.6,9.3z M90.1,13.1c-0.9,1-1.3,2.3-1.3,3.9s0.4,3,1.3,3.9\n      c0.9,0.9,2,1.4,3.5,1.4c1.4,0,2.5-0.5,3.4-1.4c0.9-1,1.4-2.3,1.4-3.9c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.4-3.4-1.4\n      C92.2,11.7,91,12.1,90.1,13.1z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M111.1,9.2c1-0.6,2.2-0.9,3.5-0.9v4.6h-1.3c-3.2,0-4.7,1.5-4.7,4.4v8.2h-2c-1.3,0-2.3-1-2.3-2.3V10.4\n      c0-1,0.8-1.9,1.9-1.9h2.4v3.2C109.2,10.7,110,9.8,111.1,9.2z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M126.8,21.7v3.7h-2.3c-1.9,0-3.3-0.5-4.4-1.4c-1-0.9-1.5-2.4-1.5-4.6v-7.3h-2.4V8.5h2.4V6\n      c0-0.9,0.8-1.7,1.7-1.7h2.6v4.2h3.8v3.6H124c-0.6,0-1,0.5-1,1v6.4c0,0.8,0.2,1.4,0.5,1.7c0.3,0.3,0.9,0.5,1.6,0.5H126.8z"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M147.4,4.6c1.7,1.3,3,3.1,3.7,5.4h-2.3c-0.6-1.6-1.6-2.9-2.9-3.8c-1.4-0.9-3.1-1.4-5.1-1.4\n      c-1.5,0-2.9,0.4-4.2,1.1c-1.3,0.8-2.2,1.8-3,3.3c-0.7,1.4-1.1,3.1-1.1,4.9s0.4,3.5,1.1,4.9c0.7,1.4,1.7,2.5,3,3.2\n      c1.3,0.8,2.6,1.1,4.2,1.1c2,0,3.7-0.5,5.1-1.4c1.4-0.9,2.3-2.2,2.9-3.8h2.3c-0.7,2.3-1.9,4.1-3.7,5.4c-1.7,1.3-4,1.9-6.6,1.9\n      c-2,0-3.9-0.5-5.5-1.5c-1.6-1-2.8-2.3-3.7-4c-0.9-1.7-1.3-3.7-1.3-5.9c0-2.2,0.4-4.2,1.3-5.9c0.9-1.7,2.1-3.1,3.7-4\n      c1.6-1,3.4-1.4,5.5-1.4C143.4,2.6,145.6,3.3,147.4,4.6z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M158.7,8.6c1.1-0.7,2.5-1,4.1-1V10h-0.7c-1.7,0-3,0.4-4.1,1.3c-1.1,0.9-1.6,2.4-1.6,4.4v9.4h-2.2V7.9h2.2v3.6\n      C156.8,10.2,157.6,9.2,158.7,8.6z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M176.1,22.3c1.1-0.8,1.7-1.8,1.9-3.2h2.3c-0.3,1.8-1.2,3.3-2.6,4.5c-1.4,1.1-3.2,1.7-5.4,1.7\n      c-1.6,0-3.1-0.4-4.4-1.1c-1.3-0.7-2.3-1.7-3-3.1c-0.7-1.3-1.1-2.9-1.1-4.7s0.4-3.4,1.1-4.7c0.7-1.3,1.7-2.4,3-3.1\n      c1.3-0.7,2.7-1.1,4.4-1.1c1.7,0,3.1,0.4,4.4,1.1c1.2,0.7,2.2,1.6,2.8,2.8c0.6,1.2,1,2.5,1,3.9c0,0.6,0,1.1-0.1,1.6H166\n      c0,1.5,0.3,2.7,0.9,3.6c0.6,1,1.3,1.7,2.3,2.2c0.9,0.5,1.9,0.7,3,0.7C173.7,23.5,175,23.1,176.1,22.3z M169.2,10.1\n      c-0.9,0.5-1.7,1.2-2.3,2.1c-0.6,1-0.9,2.2-0.9,3.6h12.2c0.1-1.4-0.1-2.6-0.7-3.6c-0.5-1-1.3-1.7-2.2-2.1c-0.9-0.5-1.9-0.7-3-0.7\n      C171.2,9.5,170.1,9.7,169.2,10.1z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M206.6,7.9l-5.1,17.2h-2.3L194,10.5l-5.2,14.7h-2.3l-5.1-17.2h2.2l4.1,14.9l5.2-14.9h2.3l5.2,14.9l4.1-14.9\n      H206.6z"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "d": "M26,24c-2.4,3-6.1,4.9-10.2,4.9C8.5,28.9,2.6,23,2.6,15.7c0-7.3,5.9-13.2,13.2-13.2c4.1,0,7.7,1.9,10.2,4.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M28.9,19l-2.7-2.7c-0.3-0.3-0.3-0.8,0-1.1l2.7-2.7c0.5-0.5,1.3-0.1,1.3,0.5v5.4C30.2,19.1,29.4,19.4,28.9,19z"
    }
  })]);
};
var __vue_staticRenderFns__$x = [];

/* style */
const __vue_inject_styles__$x = function (inject) {
  if (!inject) return;
  inject("data-v-07bb8959_0", {
    source: ".st0[data-v-07bb8959]{fill:#fff}.st1[data-v-07bb8959]{fill:none;stroke:#f4c43d;stroke-width:4.0687;stroke-linecap:round;stroke-miterlimit:10}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$x = "data-v-07bb8959";
/* module identifier */
const __vue_module_identifier__$x = undefined;
/* functional template */
const __vue_is_functional_template__$x = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, createInjector, undefined, undefined);

var script$w = defineComponent({
  name: 'Airplane',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Airplane'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$w = script$w;

/* template */
var __vue_render__$w = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "svgicon",
    attrs: {
      "d": "M16.9,11.3c0-0.3-0.2-0.6-0.4-0.7l-6.3-3.8V2.7c0-0.7-0.6-2-1.3-2s-1.3,1.3-1.3,2v4.1l-6.3,3.8C1,10.8,0.9,11,0.9,11.3c0,0.6,0.6,1,1.1,0.8l5.6-1.7l0.2,4l-1.7,1.1c-0.1,0.1-0.2,0.2-0.2,0.3v0.5c0,0.3,0.3,0.5,0.5,0.4l2.4-0.7l2.4,0.7c0.3,0.1,0.5-0.1,0.5-0.4v-0.5c0-0.1-0.1-0.3-0.2-0.3l-1.7-1.1l0.2-4l5.6,1.7C16.3,12.3,16.9,11.9,16.9,11.3z"
    }
  })])]);
};
var __vue_staticRenderFns__$w = [];

/* style */
const __vue_inject_styles__$w = undefined;
/* scoped */
const __vue_scope_id__$w = undefined;
/* module identifier */
const __vue_module_identifier__$w = undefined;
/* functional template */
const __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);

var script$v = defineComponent({
  name: 'AirplaneBegin',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'AirplaneBegin'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$v = script$v;

/* template */
var __vue_render__$v = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "svgicon",
    attrs: {
      "d": "M2.5,19h19v2h-19V19z M22.07,9.64c-0.21-0.8-1.04-1.28-1.84-1.06L14.92,10l-6.9-6.43L6.09,4.08l4.14,7.17l-4.97,1.33 l-1.97-1.54l-1.45,0.39l2.59,4.49c0,0,7.12-1.9,16.57-4.43C21.81,11.26,22.28,10.44,22.07,9.64z"
    }
  })])]);
};
var __vue_staticRenderFns__$v = [];

/* style */
const __vue_inject_styles__$v = undefined;
/* scoped */
const __vue_scope_id__$v = undefined;
/* module identifier */
const __vue_module_identifier__$v = undefined;
/* functional template */
const __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);

var script$u = defineComponent({
  name: 'AirplaneEnd',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'AirplaneEnd'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$u = script$u;

/* template */
var __vue_render__$u = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "svgicon",
    attrs: {
      "d": "M2.5,19h19v2h-19V19z M19.34,15.85c0.8,0.21,1.62-0.26,1.84-1.06c0.21-0.8-0.26-1.62-1.06-1.84l-5.31-1.42l-2.76-9.02 L10.12,2v8.28L5.15,8.95L4.22,6.63L2.77,6.24v5.17L19.34,15.85z"
    }
  })])]);
};
var __vue_staticRenderFns__$u = [];

/* style */
const __vue_inject_styles__$u = undefined;
/* scoped */
const __vue_scope_id__$u = undefined;
/* module identifier */
const __vue_module_identifier__$u = undefined;
/* functional template */
const __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);

var script$t = defineComponent({
  name: 'ClipboardCheck',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'ClipboardCheck'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$t = script$t;

/* template */
var __vue_render__$t = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M5,5h2v1c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V5h2v5h2V5c0-1.1-0.9-2-2-2h-4.18C14.4,1.84,13.3,1,12,1S9.6,1.84,9.18,3H5 C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h6v-2H5V5z M12,3c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S11.45,3,12,3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21.75,12.25c-0.41-0.41-1.09-0.41-1.5,0L15.51,17l-2.26-2.25c-0.41-0.41-1.08-0.41-1.5,0l0,0c-0.41,0.41-0.41,1.09,0,1.5 l3.05,3.04c0.39,0.39,1.02,0.39,1.41,0l5.53-5.54C22.16,13.34,22.16,12.66,21.75,12.25z"
    }
  })])])]);
};
var __vue_staticRenderFns__$t = [];

/* style */
const __vue_inject_styles__$t = undefined;
/* scoped */
const __vue_scope_id__$t = undefined;
/* module identifier */
const __vue_module_identifier__$t = undefined;
/* functional template */
const __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);

var script$s = defineComponent({
  name: 'Communicate',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Communicate'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$s = script$s;

/* template */
var __vue_render__$s = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M14.4,7.6c0,0.6,0,1.2,0,1.8c1.1,0,2.5,0,3.6,0c0-0.6,0-1.2,0-1.8C16.9,7.6,15.5,7.6,14.4,7.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.6,13.6c0.9,0.6,2,1.5,2.9,2.2c0.4-0.5,0.7-1,1.1-1.4c-0.9-0.7-2-1.5-2.9-2.2C13.3,12.6,12.9,13.1,12.6,13.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.5,2.8c-0.4-0.5-0.7-1-1.1-1.4c-0.9,0.7-2,1.5-2.9,2.2c0.4,0.5,0.7,1,1.1,1.4C14.5,4.3,15.6,3.5,16.5,2.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.8,5.8C0.8,5.8,0,6.7,0,7.6v1.8c0,1,0.8,1.8,1.8,1.8h0.9v3.6h1.8v-3.6h0.9l4.5,2.7V3.1L5.4,5.8H1.8z M6.3,7.4l1.8-1.1v4.4L6.3,9.7L5.9,9.4H5.4H1.8V7.6h3.6h0.5L6.3,7.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.1,8.5c0-1.2-0.5-2.3-1.4-3v6C11.6,10.8,12.1,9.7,12.1,8.5z"
    }
  })])]);
};
var __vue_staticRenderFns__$s = [];

/* style */
const __vue_inject_styles__$s = undefined;
/* scoped */
const __vue_scope_id__$s = undefined;
/* module identifier */
const __vue_module_identifier__$s = undefined;
/* functional template */
const __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);

var script$r = defineComponent({
  name: 'CrewNote',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'CrewNote'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$r = script$r;

/* template */
var __vue_render__$r = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M464 64H192c-8.8 0-16 7.7-16 16.5V112H74c-23.1 0-42 18.9-42 42v207.5c0 47.6 39 86.5 86 86.5h279.7c45.1 0 82.3-36.9 82.3-82V80c0-8.8-7.2-16-16-16zm-288 80v192h-42V163.2c0-6.8-.8-13.3-3.3-19.2H176zm-17 255.4C148 410 133.2 416 118.5 416c-14.5 0-28.1-5.7-38.5-16-10.3-10.3-16-24-16-38.5V163.2c0-10.6 8.4-19.2 19-19.2s19 8.6 19 19.2V352c0 8.8 7.2 16 16 16h57.5c-1.5 11.6-7.2 22.6-16.5 31.4zM448 366c0 13.3-5.4 25.8-14.9 35.3-9.5 9.5-22.2 14.7-35.4 14.7H187.3c12.8-14.9 20.7-33.9 20.7-54.5V97h240v269z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M248 136h160v56H248zM248 224h160v32H248zM248 288h160v32H248zM408 352H248s0 32-8 32h148.7c19.3 0 19.3-21 19.3-32z"
    }
  })])]);
};
var __vue_staticRenderFns__$r = [];

/* style */
const __vue_inject_styles__$r = undefined;
/* scoped */
const __vue_scope_id__$r = undefined;
/* module identifier */
const __vue_module_identifier__$r = undefined;
/* functional template */
const __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);

var script$q = defineComponent({
  name: 'Event',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Event'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$q = script$q;

/* template */
var __vue_render__$q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20 12c0-.76.43-1.42 1.06-1.76.6-.33.94-1.01.94-1.7V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.89-1.99 1.99v2.55c0 .69.33 1.37.94 1.69C3.58 10.58 4 11.24 4 12s-.43 1.43-1.06 1.76c-.6.33-.94 1.01-.94 1.7V18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-2.54c0-.69-.34-1.37-.94-1.7-.63-.34-1.06-1-1.06-1.76zm-5.5 4.1L12 14.5l-2.5 1.61c-.38.24-.87-.11-.75-.55l.75-2.88-2.3-1.88c-.35-.29-.17-.86.29-.89l2.96-.17 1.08-2.75c.17-.42.77-.42.93 0l1.08 2.76 2.96.17c.45.03.64.6.29.89l-2.3 1.88.76 2.86c.12.45-.37.8-.75.55z"
    }
  })]);
};
var __vue_staticRenderFns__$q = [];

/* style */
const __vue_inject_styles__$q = undefined;
/* scoped */
const __vue_scope_id__$q = undefined;
/* module identifier */
const __vue_module_identifier__$q = undefined;
/* functional template */
const __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);

var script$p = defineComponent({
  name: 'Group',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Group'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$p = script$p;

/* template */
var __vue_render__$p = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M12,12.8c1.6,0,3.1,0.4,4.2,0.9s1.8,1.6,1.8,2.7V17c0,0.5-0.5,1-1,1H7c-0.6,0-1-0.5-1-1v-0.6c0-1.2,0.7-2.3,1.8-2.7\nC8.9,13.1,10.4,12.8,12,12.8z M4,13c1.1,0,2-0.9,2-2S5.1,9,4,9s-2,0.9-2,2S2.9,13,4,13z M5.1,14.1C4.8,14,4.4,14,4,14\nc-1,0-1.9,0.2-2.8,0.6c-0.7,0.3-1.2,1-1.2,1.9V17c0,0.5,0.4,1,1,1h3.5v-1.6C4.5,15.6,4.7,14.8,5.1,14.1z M20,13c1.1,0,2-0.9,2-2\ns-0.9-2-2-2s-2,0.9-2,2S18.9,13,20,13z M24,16.4c0-0.8-0.5-1.5-1.2-1.9C21.9,14.2,21,14,20,14c-0.4,0-0.8,0-1.1,0.1\nc0.4,0.7,0.6,1.5,0.6,2.3V18H23c0.5,0,1-0.5,1-1V16.4z M12,6c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S10.3,6,12,6z"
    }
  })])]);
};
var __vue_staticRenderFns__$p = [];

/* style */
const __vue_inject_styles__$p = undefined;
/* scoped */
const __vue_scope_id__$p = undefined;
/* module identifier */
const __vue_module_identifier__$p = undefined;
/* functional template */
const __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);

var script$o = defineComponent({
  name: 'History',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'History'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$o = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 18",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "svgicon",
    attrs: {
      "d": "M10.3,1.3C6,1.3,2.6,4.7,2.6,9H0l3.3,3.3l0.1,0.1L6.9,9H4.3c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6c-1.7,0-3.2-0.7-4.2-1.8l-1.2,1.2c1.4,1.4,3.3,2.3,5.5,2.3c4.3,0,7.7-3.5,7.7-7.7S14.6,1.3,10.3,1.3z M9.4,5.6v4.3l3.7,2.2l0.6-1l-3-1.8V5.6H9.4z"
    }
  })])]);
};
var __vue_staticRenderFns__$o = [];

/* style */
const __vue_inject_styles__$o = undefined;
/* scoped */
const __vue_scope_id__$o = undefined;
/* module identifier */
const __vue_module_identifier__$o = undefined;
/* functional template */
const __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);

var script$n = defineComponent({
  name: 'MoreMenu',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'MoreMenu'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 16 16",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "svgicon",
    attrs: {
      "d": "M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
    }
  })])]);
};
var __vue_staticRenderFns__$n = [];

/* style */
const __vue_inject_styles__$n = undefined;
/* scoped */
const __vue_scope_id__$n = undefined;
/* module identifier */
const __vue_module_identifier__$n = undefined;
/* functional template */
const __vue_is_functional_template__$n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, undefined, undefined, undefined);

var script$m = defineComponent({
  name: 'PenciFill',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'PencilFill'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$m = script$m;

/* template */
var __vue_render__$m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 16 16",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
    }
  })])]);
};
var __vue_staticRenderFns__$m = [];

/* style */
const __vue_inject_styles__$m = undefined;
/* scoped */
const __vue_scope_id__$m = undefined;
/* module identifier */
const __vue_module_identifier__$m = undefined;
/* functional template */
const __vue_is_functional_template__$m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, undefined, undefined, undefined);

var script$l = defineComponent({
  name: 'People',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'People'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$l = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "enable-background": "new 0 0 24 24",
      "viewBox": "0 0 24 24",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "fill": "none",
      "height": "24",
      "width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "fill": "none",
      "height": "24",
      "width": "24"
    }
  })]), _vm._v(" "), _c('g', [_c('g'), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M16.67,13.13C18.04,14.06,19,15.32,19,17v3h3c0.55,0,1-0.45,1-1v-2 C23,14.82,19.43,13.53,16.67,13.13z",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('g', [_c('circle', {
    attrs: {
      "cx": "9",
      "cy": "8",
      "fill-rule": "evenodd",
      "r": "4"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M15,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4c-0.47,0-0.91,0.1-1.33,0.24 C14.5,5.27,15,6.58,15,8s-0.5,2.73-1.33,3.76C14.09,11.9,14.53,12,15,12z",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M9,13c-2.67,0-8,1.34-8,4v2c0,0.55,0.45,1,1,1h14c0.55,0,1-0.45,1-1v-2 C17,14.34,11.67,13,9,13z",
      "fill-rule": "evenodd"
    }
  })])])])]);
};
var __vue_staticRenderFns__$l = [];

/* style */
const __vue_inject_styles__$l = undefined;
/* scoped */
const __vue_scope_id__$l = undefined;
/* module identifier */
const __vue_module_identifier__$l = undefined;
/* functional template */
const __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);

var script$k = defineComponent({
  name: 'Platform',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Platform'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M487.83,319.44,295.63,36.88a48,48,0,0,0-79.26,0L24.17,319.44A47.1,47.1,0,0,0,41.1,387.57L233.3,490.32a48.05,48.05,0,0,0,45.4,0L470.9,387.57a47.1,47.1,0,0,0,16.93-68.13Zm-431.26,41a16.12,16.12,0,0,1-8-10.38,16.8,16.8,0,0,1,2.37-13.62L232.66,69.26c2.18-3.21,7.34-1.72,7.34,2.13v374c0,5.9-6.54,9.63-11.87,6.78Z"
    }
  })]);
};
var __vue_staticRenderFns__$k = [];

/* style */
const __vue_inject_styles__$k = undefined;
/* scoped */
const __vue_scope_id__$k = undefined;
/* module identifier */
const __vue_module_identifier__$k = undefined;
/* functional template */
const __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

var script$j = defineComponent({
  name: 'PositionNote',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'PositionNote'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 14.7",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "Path_262",
      "d": "M15,1.2c-0.4-0.5-1-0.8-1.6-0.8l-11,0c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2l11,0\n    c0.6,0,1.3-0.3,1.6-0.8l4.4-6.2L15,1.2z"
    }
  })])]);
};
var __vue_staticRenderFns__$j = [];

/* style */
const __vue_inject_styles__$j = undefined;
/* scoped */
const __vue_scope_id__$j = undefined;
/* module identifier */
const __vue_module_identifier__$j = undefined;
/* functional template */
const __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

var script$i = defineComponent({
  name: 'Rates',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Rates'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "svgicon",
    attrs: {
      "d": "M13,10c-0.4-0.5-0.8-0.9-1.3-1.1c-0.5-0.3-1.2-0.5-2-0.8C9.1,7.9,8.6,7.7,8.3,7.6C8,7.4,7.7,7.2,7.5,7C7.2,6.7,7.1,6.4,7.1,6c0-0.5,0.1-0.8,0.4-1.1c0.3-0.2,0.7-0.4,1.1-0.4c0.5,0,1,0.1,1.3,0.4s0.5,0.7,0.6,1.1h2.7c-0.1-1.1-0.6-1.9-1.4-2.6C11.3,3,10.6,2.7,9.9,2.6V0.5H7.6v2.2c-0.8,0.1-1.4,0.4-2,0.8C4.8,4.2,4.4,5,4.4,6.1c0,0.8,0.2,1.5,0.5,1.9c0.4,0.5,0.8,0.9,1.3,1.1c0.5,0.3,1.2,0.6,2,0.9c0.6,0.2,1.1,0.4,1.4,0.5c0.3,0.2,0.6,0.4,0.9,0.6c0.2,0.3,0.3,0.6,0.3,1s-0.1,0.8-0.4,1.1c-0.3,0.3-0.7,0.4-1.2,0.4c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.3-0.6-0.8-0.6-1.3H4.4c0.1,0.8,0.3,1.4,0.7,2c0.4,0.6,1,1,1.7,1.3c0.3,0.1,0.5,0.2,0.8,0.3v2.1H10v-2c0.6-0.1,1.1-0.2,1.5-0.4c0.6-0.3,1.1-0.8,1.4-1.3c0.3-0.5,0.5-1.1,0.5-1.8C13.5,11.2,13.3,10.5,13,10z"
    }
  })])]);
};
var __vue_staticRenderFns__$i = [];

/* style */
const __vue_inject_styles__$i = undefined;
/* scoped */
const __vue_scope_id__$i = undefined;
/* module identifier */
const __vue_module_identifier__$i = undefined;
/* functional template */
const __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);

var script$h = defineComponent({
  name: 'Receipt',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Receipt'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M483.82,32.45a16.28,16.28,0,0,0-11.23,1.37L448,46.1h0l-24.8-12.4a16,16,0,0,0-14.31,0L383.78,46.11h0L359,33.7a16,16,0,0,0-14.36,0L320,46.07H320L295.55,33.73a16,16,0,0,0-14.35-.06L256,46.12h0l-24.8-12.43a16.05,16.05,0,0,0-14.33,0L192,46.1h0L167.16,33.69a16,16,0,0,0-19.36,3.94A16.25,16.25,0,0,0,144,48.28V288a0,0,0,0,0,.05.05H336a32,32,0,0,1,32,32V424c0,30.93,33.07,56,64,56h12a52,52,0,0,0,52-52V48A16,16,0,0,0,483.82,32.45ZM416,240H288.5c-8.64,0-16.1-6.64-16.48-15.28A16,16,0,0,1,288,208H415.5c8.64,0,16.1,6.64,16.48,15.28A16,16,0,0,1,416,240Zm0-80H224.5c-8.64,0-16.1-6.64-16.48-15.28A16,16,0,0,1,224,128H415.5c8.64,0,16.1,6.64,16.48,15.28A16,16,0,0,1,416,160Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M336,424V336a16,16,0,0,0-16-16H48a32.1,32.1,0,0,0-32,32.05c0,50.55,5.78,71.57,14.46,87.57C45.19,466.79,71.86,480,112,480H357.68a4,4,0,0,0,2.85-6.81C351.07,463.7,336,451,336,424Z"
    }
  })])]);
};
var __vue_staticRenderFns__$h = [];

/* style */
const __vue_inject_styles__$h = undefined;
/* scoped */
const __vue_scope_id__$h = undefined;
/* module identifier */
const __vue_module_identifier__$h = undefined;
/* functional template */
const __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

var script$g = defineComponent({
  name: 'Speaker',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Speaker'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 16 16",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-2.5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM8 7a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7z"
    }
  })]);
};
var __vue_staticRenderFns__$g = [];

/* style */
const __vue_inject_styles__$g = undefined;
/* scoped */
const __vue_scope_id__$g = undefined;
/* module identifier */
const __vue_module_identifier__$g = undefined;
/* functional template */
const __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

var script$f = defineComponent({
  name: 'Stats',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Stats'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M159.8,511.3h63.9c5.9,0,10.7-4.8,10.7-10.7v-490c0-5.9-4.8-10.7-10.7-10.7h-63.9c-5.9,0-10.7,4.8-10.7,10.7v490C149.2,506.5,153.9,511.3,159.8,511.3z M32,511.3h63.9c5.9,0,10.7-4.8,10.7-10.7V308.9c0-5.9-4.8-10.7-10.7-10.7H32c-5.9,0-10.7,4.8-10.7,10.7v191.7C21.3,506.5,26.1,511.3,32,511.3z M287.8,511.3h63.6c6,0,10.8-4.8,10.8-10.8V223.8c0-6-4.8-10.8-10.8-10.8h-63.6c-6,0-10.8,4.8-10.8,10.8v276.7C277,506.5,281.8,511.3,287.8,511.3L287.8,511.3z M404.8,96v404.5c0,6,4.8,10.8,10.8,10.8h63.6c6,0,10.8-4.8,10.8-10.8V96c0-6-4.8-10.8-10.8-10.8h-63.6C409.6,85.2,404.8,90,404.8,96z"
    }
  })])]);
};
var __vue_staticRenderFns__$f = [];

/* style */
const __vue_inject_styles__$f = undefined;
/* scoped */
const __vue_scope_id__$f = undefined;
/* module identifier */
const __vue_module_identifier__$f = undefined;
/* functional template */
const __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);

var script$e = defineComponent({
  name: 'Supervisors',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Supervisors'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M20,7h-5V4c0-1.1-0.9-2-2-2h-2C9.9,2,9,2.9,9,4v3H4C2.9,7,2,7.9,2,9v11c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V9   C22,7.9,21.1,7,20,7z M9,12c0.8,0,1.5,0.7,1.5,1.5S9.8,15,9,15s-1.5-0.7-1.5-1.5S8.2,12,9,12z M12,18H6v-0.8c0-1,2-1.5,3-1.5   s3,0.5,3,1.5V18z M13,9h-2V4h2V9z M18,16.5h-4V15h4V16.5z M18,13.5h-4V12h4V13.5z"
    }
  })])]);
};
var __vue_staticRenderFns__$e = [];

/* style */
const __vue_inject_styles__$e = undefined;
/* scoped */
const __vue_scope_id__$e = undefined;
/* module identifier */
const __vue_module_identifier__$e = undefined;
/* functional template */
const __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

var script$d = defineComponent({
  name: 'Venue',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Venue'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 16 16",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M14.8,0.1c-0.1-0.1-0.3-0.1-0.5,0l-8,4C6.1,4.1,6,4.3,6,4.5v3.1L0.3,9.5C0.1,9.6,0,9.8,0,10v5.5C0,15.8,0.2,16,0.5,16h9  c0.3,0,0.5-0.2,0.5-0.5V14h1v1.5c0,0.3,0.2,0.5,0.5,0.5h3c0.3,0,0.5-0.2,0.5-0.5v-15C15,0.3,14.9,0.2,14.8,0.1z M3,14H2v-1h1V14z   M3,12H2v-1h1V12z M5,14H4v-1h1V14z M5,12H4v-1h1V12z M9,12H8v-1h1V12z M9,10H8V9h1V10z M9,8H8V7h1V8z M9,6H8V5h1V6z M11,12h-1v-1h1  V12z M11,10h-1V9h1V10z M11,8h-1V7h1V8z M11,6h-1V5h1V6z M13,12h-1v-1h1V12z M13,10h-1V9h1V10z M13,8h-1V7h1V8z M13,6h-1V5h1V6z   M13,4h-1V3h1V4z"
    }
  })])]);
};
var __vue_staticRenderFns__$d = [];

/* style */
const __vue_inject_styles__$d = undefined;
/* scoped */
const __vue_scope_id__$d = undefined;
/* module identifier */
const __vue_module_identifier__$d = undefined;
/* functional template */
const __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

var script$c = defineComponent({
  name: 'Wallet',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Wallet'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M95.5,104h320a87.73,87.73,0,0,1,11.18.71,66,66,0,0,0-77.51-55.56L86,94.08l-.3,0a66,66,0,0,0-41.07,26.13A87.57,87.57,0,0,1,95.5,104Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M415.5,128H95.5a64.07,64.07,0,0,0-64,64V384a64.07,64.07,0,0,0,64,64h320a64.07,64.07,0,0,0,64-64V192A64.07,64.07,0,0,0,415.5,128ZM368,320a32,32,0,1,1,32-32A32,32,0,0,1,368,320Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,259.5V160c0-21.67,12-58,53.65-65.87C121,87.5,156,87.5,156,87.5s23,16,4,16S141.5,128,160,128s0,23.5,0,23.5L85.5,236Z"
    }
  })]);
};
var __vue_staticRenderFns__$c = [];

/* style */
const __vue_inject_styles__$c = undefined;
/* scoped */
const __vue_scope_id__$c = undefined;
/* module identifier */
const __vue_module_identifier__$c = undefined;
/* functional template */
const __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

var script$b = defineComponent({
  name: 'Warehouse',
  props: {
    name: {
      type: String,
      required: false,
      default: () => 'Warehouse'
    },
    size: {
      type: String,
      required: false,
      default: () => 'md'
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    hoverColor: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup: props => {
    // props
    const {
      size,
      color,
      hoverColor
    } = toRefs(props);
    // template ref
    const svg = ref(null);
    // computed
    const width = computed(() => {
      return IconSizes[size.value];
    });
    const height = computed(() => {
      return IconSizes[size.value];
    });
    const fillColor = computed(() => {
      return `var(--${color.value})`;
    });
    const iconHoverColor = computed(() => {
      return `var(--${hoverColor.value})`;
    });
    // functions
    const onMouseOver = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = iconHoverColor.value;
      }
    };
    const onMouseOut = () => {
      if (hoverColor?.value) {
        svg.value.style.fill = fillColor.value;
      }
    };
    return {
      svg,
      width,
      height,
      fillColor,
      onMouseOver,
      onMouseOut
    };
  }
});

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    ref: "svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "role": "presentation",
      "fill": _vm.fillColor,
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.name
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.name,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M22,19V8.35c0-0.82-0.5-1.55-1.26-1.86l-8-3.2c-0.48-0.19-1.01-0.19-1.49,0l-8,3.2C2.5,6.8,2,7.54,2,8.35V19 c0,1.1,0.9,2,2,2h3v-9h10v9h3C21.1,21,22,20.1,22,19z M11,19H9v2h2V19z M13,16h-2v2h2V16z M15,19h-2v2h2V19z"
    }
  })])]);
};
var __vue_staticRenderFns__$b = [];

/* style */
const __vue_inject_styles__$b = undefined;
/* scoped */
const __vue_scope_id__$b = undefined;
/* module identifier */
const __vue_module_identifier__$b = undefined;
/* functional template */
const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var script$a = defineComponent({
  name: 'Toast',
  props: {
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    delay: {
      type: String,
      required: false,
      default: () => '5000'
    }
  },
  setup: props => {
    const {
      type
    } = toRefs(props);
    const bvToast = ref();
    const variant = computed(() => {
      if (type.value === 'error') {
        return 'danger';
      }
      return type.value;
    });
    const show = () => {
      bvToast.value?.show();
    };
    return {
      bvToast,
      variant,
      show
    };
  }
});

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('b-toast', {
    ref: "bvToast",
    attrs: {
      "id": "toast",
      "toaster": "b-toaster-top-center",
      "variant": _vm.variant,
      "auto-hide-delay": _vm.delay,
      "solid": ""
    },
    scopedSlots: _vm._u([{
      key: "toast-title",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "mr-2"
        }, [_vm.type === 'success' ? _c('b-icon-check', {
          attrs: {
            "variant": "success",
            "font-scale": "2"
          }
        }) : _vm.type === 'error' ? _c('b-icon-exclamation-octagon-fill', {
          attrs: {
            "variant": "danger",
            "font-scale": "2"
          }
        }) : _vm.type === 'warning' ? _c('b-icon-exclamation', {
          attrs: {
            "variant": "warning",
            "font-scale": "2"
          }
        }) : _vm.type === 'info' ? _c('b-icon-info', {
          attrs: {
            "variant": "info",
            "font-scale": "2"
          }
        }) : _vm._e()], 1), _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_vm._v("\n  " + _vm._s(_vm.message) + "\n")]);
};
var __vue_staticRenderFns__$a = [];

/* style */
const __vue_inject_styles__$a = undefined;
/* scoped */
const __vue_scope_id__$a = undefined;
/* module identifier */
const __vue_module_identifier__$a = undefined;
/* functional template */
const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

const TOKEN_NAME = 'X-CSRFToken'.toLowerCase();
let csrf;
function addCSRFToRequest(conf) {
  const config = {
    ...conf
  };
  if (csrf) {
    config.headers = config.headers || {};
    config.headers[TOKEN_NAME] = csrf;
  }
  return config;
}
function parseCSRFFromResponse(response) {
  const newCsrf = response.headers[TOKEN_NAME];
  if (newCsrf) {
    csrf = newCsrf;
  }
  return response;
}
function parseCSRFFromError(e) {
  if (e.response && e.response.headers[TOKEN_NAME]) {
    csrf = e.response.headers[TOKEN_NAME];
  }
  throw e;
}
function registerCSRFInterceptors(axiosInstance) {
  axiosInstance.interceptors.request.use(addCSRFToRequest);
  axiosInstance.interceptors.response.use(parseCSRFFromResponse, parseCSRFFromError);
}

//
var script$9 = defineComponent({
  name: 'UserPreferencesSidebar',
  props: {
    accountSubdomain: String,
    // Workforce API requires account subdomain.
    baseUrl: String // optional override
  },

  setup(props, ctx) {
    // region baseUrl
    const hostnameParts = window.location.hostname.split('.');
    let {
      baseUrl
    } = props;
    if (!props.baseUrl) {
      baseUrl = `https://${props.accountSubdomain}.lasso.io`;
      if (hostnameParts.includes('test')) {
        baseUrl = `https://${props.accountSubdomain}.test.lasso.io`;
      } else if (hostnameParts.includes('sandbox')) {
        baseUrl = `https://${props.accountSubdomain}.sandbox.lasso.io`;
      } else if (hostnameParts.includes('local')) {
        baseUrl = `http://${props.accountSubdomain}.local.lasso.io:8000`;
      }
    }
    const myAxios = axios.create({
      baseURL: baseUrl,
      withCredentials: true,
      // allow server to read cookie
      headers: {
        'Content-Type': 'application/json'
      }
    });
    registerCSRFInterceptors(myAxios);
    myAxios('/initialize_vue/', {
      method: 'GET',
      withCredentials: true
    });
    // endregion baseUrl
    const form = ref(null);
    const userData = ref({});
    const firstName = ref('');
    const lastName = ref('');
    const email = ref('');
    const phone = ref('');
    const allNotifications = ref(false);
    const allProjNotifications = ref(false);
    const projEmailNotifications = ref(false);
    const projSmsNotifications = ref(false);
    const allChatNotifications = ref(false);
    const chatEmailNotifications = ref(false);
    const chatSmsNotifications = ref(false);
    const saveDisabled = ref(false);
    const assignResponseData = responseData => {
      firstName.value = responseData.user_preferences.first_name;
      lastName.value = responseData.user_preferences.last_name;
      email.value = responseData.user_preferences.email;
      phone.value = responseData.user_preferences.phone;
      projEmailNotifications.value = responseData.user_preferences.project_email_notifications;
      projSmsNotifications.value = responseData.user_preferences.project_sms_notifications;
      chatEmailNotifications.value = responseData.user_preferences.chat_email_notifications;
      chatSmsNotifications.value = responseData.user_preferences.chat_sms_notifications;
    };
    function makePostData() {
      return {
        user: {
          first_name: firstName.value,
          last_name: lastName.value
        },
        user_preferences: {
          project_email_notifications: projEmailNotifications.value,
          project_sms_notifications: projSmsNotifications.value,
          chat_email_notifications: chatEmailNotifications.value,
          chat_sms_notifications: chatSmsNotifications.value
        }
      };
    }
    async function getUserPreferences() {
      await myAxios.get('/next_api/user/preferences/').then(response => {
        if (response.data) {
          assignResponseData(response.data);
        }
      });
    }
    async function updateUserPreferences() {
      if (!form.value.checkValidity()) {
        form.value.reportValidity();
        return;
      }
      saveDisabled.value = true;
      await myAxios.post('/next_api/user/preferences/update/', makePostData(), {
        withCredentials: true
      }).then(result => {
        assignResponseData(result.data);
      }).then(() => {
        saveDisabled.value = false;
      });
    }
    // allProjNotifications and allChatNotifications should be true if both of their child checkboxes are checked.
    const checkAllProjNotifs = () => {
      allProjNotifications.value = !!projEmailNotifications.value && !!projSmsNotifications.value;
    };
    const checkAllChatNotifs = () => {
      allChatNotifications.value = !!chatEmailNotifications.value && !!chatSmsNotifications.value;
    };

    // When allProjNotifications or allChatNotifications boxes are clicked, child checkboxes will have the same value.
    const allProjNotifsButtonClicked = () => {
      projEmailNotifications.value = allProjNotifications.value;
      projSmsNotifications.value = allProjNotifications.value;
    };
    const allChatNotifsButtonClicked = () => {
      chatEmailNotifications.value = allChatNotifications.value;
      chatSmsNotifications.value = allChatNotifications.value;
    };

    // When allNotifications button is clicked, all checkboxes should have the same value.
    const allNotfisButtonClicked = () => {
      projEmailNotifications.value = allNotifications.value;
      projSmsNotifications.value = allNotifications.value;
      chatEmailNotifications.value = allNotifications.value;
      chatSmsNotifications.value = allNotifications.value;
      checkAllProjNotifs();
      checkAllChatNotifs();
    };
    function loadData() {
      getUserPreferences().then(() => {
        checkAllProjNotifs();
        checkAllChatNotifs();
      });
    }
    // if allChatNotifications & allProjNotifcations are true, allNotifications should also be true.
    watch([allChatNotifications, allProjNotifications], () => {
      allNotifications.value = !!allProjNotifications.value && !!allChatNotifications.value;
    });
    return {
      loadData,
      getUserPreferences,
      userData,
      firstName,
      lastName,
      email,
      phone,
      allProjNotifications,
      projEmailNotifications,
      projSmsNotifications,
      allChatNotifications,
      chatEmailNotifications,
      chatSmsNotifications,
      allNotifications,
      saveDisabled,
      checkAllProjNotifs,
      checkAllChatNotifs,
      updateUserPreferences,
      allProjNotifsButtonClicked,
      allChatNotifsButtonClicked,
      allNotfisButtonClicked,
      form
    };
  }
});

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('b-sidebar', {
    attrs: {
      "id": "user-preferences-sidebar",
      "lazy": "",
      "right": "",
      "shadow": "",
      "no-header": "",
      "backdrop": "",
      "backdrop-variant": "transparent"
    },
    on: {
      "shown": _vm.loadData
    }
  }, [_c('div', [_c('div', {}, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.user-preferences-sidebar",
      modifiers: {
        "user-preferences-sidebar": true
      }
    }],
    attrs: {
      "variant": "link",
      "float-right": ""
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x-lg",
      "variant": "secondary",
      "shift-v": "2",
      "shift-h": "2",
      "font-scale": "1.5"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 justify-content-center align-items-center"
  }, [_c('b-icon', {
    attrs: {
      "icon": "gear-fill",
      "shift-v": "2",
      "shift-h": "2",
      "font-scale": "1.5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-0 ml-3"
  }, [_vm._v("My Profile")])], 1)], 1), _vm._v(" "), _c('b-form', {
    ref: "form"
  }, [_c('div', {
    staticClass: "user-pref-card"
  }, [_c('h5', {
    staticClass: "p-0 m-0 mb-2"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 justify-content-between align-items-start my-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-icon', {
    staticClass: "mr-3",
    attrs: {
      "icon": "person-badge-fill",
      "shift-v": "2",
      "shift-h": "2",
      "font-scale": "1"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "font-weight-normal"
  }, [_vm._v("First Name")])], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "w-50 m-0"
  }, [_c('b-form-input', {
    staticClass: "w-100",
    attrs: {
      "size": "md"
    },
    model: {
      value: _vm.firstName,
      callback: function ($$v) {
        _vm.firstName = $$v;
      },
      expression: "firstName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 justify-content-between align-items-start my-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-icon', {
    staticClass: "mr-3",
    attrs: {
      "icon": "person-badge-fill",
      "shift-v": "2",
      "shift-h": "2",
      "font-scale": "1"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "font-weight-normal"
  }, [_vm._v("Last Name")])], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "w-50 m-0"
  }, [_c('b-form-input', {
    staticClass: "w-100",
    attrs: {
      "size": "md"
    },
    model: {
      value: _vm.lastName,
      callback: function ($$v) {
        _vm.lastName = $$v;
      },
      expression: "lastName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 justify-content-between my-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-icon', {
    staticClass: "mr-3",
    attrs: {
      "icon": "envelope-fill",
      "shift-v": "2",
      "shift-h": "2",
      "font-scale": "1"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "font-weight-normal py-2 m-0"
  }, [_vm._v("Email")])], 1), _vm._v(" "), _c('h6', {
    staticClass: "font-weight-normal py-2 m-0 text-left"
  }, [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 justify-content-between my-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-icon', {
    staticClass: "mr-3",
    attrs: {
      "icon": "phone-vibrate-fill",
      "shift-v": "2",
      "shift-h": "2",
      "font-scale": "1"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "font-weight-normal py-2 m-0 text-left"
  }, [_vm._v("Phone")])], 1), _vm._v(" "), _c('h6', {
    staticClass: "font-weight-normal py-2 m-0"
  }, [_vm._v(_vm._s(_vm.phone))])]), _vm._v(" "), _c('h6', {
    staticClass: "font-weight-normal"
  }, [_vm._v("Contact Support to change Email or Phone Number")])]), _vm._v(" "), _c('div', {
    staticClass: "user-pref-card"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-checkbox', {
    staticClass: "mr-0",
    attrs: {
      "name": "all_notifications",
      "size": "lg"
    },
    on: {
      "change": function ($event) {
        return _vm.allNotfisButtonClicked();
      }
    },
    model: {
      value: _vm.allNotifications,
      callback: function ($$v) {
        _vm.allNotifications = $$v;
      },
      expression: "allNotifications"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "p-0 m-0"
  }, [_vm._v("Notifications")])], 1), _vm._v(" "), _c('b-icon', {
    staticClass: "mr-3",
    attrs: {
      "icon": "bell-fill",
      "variant": "secondary",
      "shift-h": "2",
      "font-scale": "1.2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "d-flex mt-3"
  }, [_c('b-form-checkbox', {
    attrs: {
      "size": "lg"
    },
    on: {
      "change": function ($event) {
        return _vm.allProjNotifsButtonClicked();
      }
    },
    model: {
      value: _vm.allProjNotifications,
      callback: function ($$v) {
        _vm.allProjNotifications = $$v;
      },
      expression: "allProjNotifications"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "p-0 m-0"
  }, [_vm._v("Project")])], 1), _vm._v(" "), _c('b-icon', {
    staticClass: "mr-3",
    attrs: {
      "icon": "check2-circle",
      "variant": "secondary",
      "shift-v": "-5",
      "shift-h": "2",
      "font-scale": "1.2"
    }
  })], 1), _vm._v(" "), _c('h6', {
    staticClass: "p-0 mx-0 font-weight-normal mt-2 mb-3"
  }, [_vm._v("Choose the type of notifications you get for Projects")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex ml-3 my-2"
  }, [_c('b-form-group', {
    staticClass: "m-0 p-0"
  }, [_c('b-form-checkbox', {
    attrs: {
      "size": "lg"
    },
    on: {
      "change": function ($event) {
        return _vm.checkAllProjNotifs();
      }
    },
    model: {
      value: _vm.projEmailNotifications,
      callback: function ($$v) {
        _vm.projEmailNotifications = $$v;
      },
      expression: "projEmailNotifications"
    }
  })], 1), _vm._v(" "), _c('h6', {
    staticClass: "p-0 m-0 font-weight-normal"
  }, [_vm._v("Email Notifications")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex ml-3 my-2"
  }, [_c('b-form-group', {
    staticClass: "m-0 p-0"
  }, [_c('b-form-checkbox', {
    attrs: {
      "size": "lg"
    },
    on: {
      "change": function ($event) {
        return _vm.checkAllProjNotifs();
      }
    },
    model: {
      value: _vm.projSmsNotifications,
      callback: function ($$v) {
        _vm.projSmsNotifications = $$v;
      },
      expression: "projSmsNotifications"
    }
  })], 1), _vm._v(" "), _c('h6', {
    staticClass: "p-0 m-0 font-weight-normal"
  }, [_vm._v("SMS Notifications")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mt-3"
  }, [_c('div', {
    staticClass: "d-flex mt-3"
  }, [_c('b-form-checkbox', {
    attrs: {
      "size": "lg"
    },
    on: {
      "change": function ($event) {
        return _vm.allChatNotifsButtonClicked();
      }
    },
    model: {
      value: _vm.allChatNotifications,
      callback: function ($$v) {
        _vm.allChatNotifications = $$v;
      },
      expression: "allChatNotifications"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "p-0 m-0"
  }, [_vm._v("Chat")])], 1), _vm._v(" "), _c('b-icon', {
    staticClass: "mr-3",
    attrs: {
      "icon": "chat-text-fill",
      "variant": "secondary",
      "shift-v": "-5",
      "shift-h": "2",
      "font-scale": "1"
    }
  })], 1), _vm._v(" "), _c('h6', {
    staticClass: "p-0 mx-0 font-weight-normal mt-2 mb-3"
  }, [_vm._v("Choose the type of notifications you get for Chats")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex ml-3 my-2"
  }, [_c('b-form-group', {
    staticClass: "m-0 p-0"
  }, [_c('b-form-checkbox', {
    attrs: {
      "size": "lg"
    },
    on: {
      "change": function ($event) {
        return _vm.checkAllChatNotifs();
      }
    },
    model: {
      value: _vm.chatEmailNotifications,
      callback: function ($$v) {
        _vm.chatEmailNotifications = $$v;
      },
      expression: "chatEmailNotifications"
    }
  })], 1), _vm._v(" "), _c('h6', {
    staticClass: "p-0 m-0 font-weight-normal"
  }, [_vm._v("Email Notifications")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex ml-3 my-2"
  }, [_c('b-form-group', {
    staticClass: "m-0 p-0"
  }, [_c('b-form-checkbox', {
    attrs: {
      "size": "lg"
    },
    on: {
      "change": function ($event) {
        return _vm.checkAllChatNotifs();
      }
    },
    model: {
      value: _vm.chatSmsNotifications,
      callback: function ($$v) {
        _vm.chatSmsNotifications = $$v;
      },
      expression: "chatSmsNotifications"
    }
  })], 1), _vm._v(" "), _c('h6', {
    staticClass: "p-0 m-0 font-weight-normal"
  }, [_vm._v("SMS Notifications")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('b-button', {
    attrs: {
      "pill": "",
      "variant": "primary",
      "disabled": _vm.saveDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.updateUserPreferences();
      }
    }
  }, [_vm._v(" Save ")])], 1)], 1)]);
};
var __vue_staticRenderFns__$9 = [];

/* style */
const __vue_inject_styles__$9 = function (inject) {
  if (!inject) return;
  inject("data-v-324e6671_0", {
    source: ".user-pref-card{background:#fff;padding:10px;box-shadow:rgba(0,0,0,.12) 0 1px 3px,rgba(0,0,0,.24) 0 1px 2px;border-radius:10px;margin:7px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$9 = undefined;
/* module identifier */
const __vue_module_identifier__$9 = undefined;
/* functional template */
const __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);

var script$8 = defineComponent({
  name: 'UserPreferencesDropdownItem'
});

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('b-dropdown-item-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.user-preferences-sidebar",
      modifiers: {
        "user-preferences-sidebar": true
      }
    }],
    attrs: {
      "data-test-id": "nav-user-preferences"
    }
  }, [_vm._v("\n  Edit Profile\n")]);
};
var __vue_staticRenderFns__$8 = [];

/* style */
const __vue_inject_styles__$8 = undefined;
/* scoped */
const __vue_scope_id__$8 = undefined;
/* module identifier */
const __vue_module_identifier__$8 = undefined;
/* functional template */
const __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

function isNullish (val) {
  return [null, undefined].indexOf(val) !== -1
}

function useData (props, context, dep)
{
  const { object, valueProp, mode } = toRefs(props);

  const $this = getCurrentInstance().proxy;

  // ============ DEPENDENCIES ============

  const iv = dep.iv;

  // =============== METHODS ==============

  const update = (val, triggerInput = true) => {
    // Setting object(s) as internal value
    iv.value = makeInternal(val);

    // Setting object(s) or plain value as external 
    // value based on `option` setting
    const externalVal = makeExternal(val);

    context.emit('change', externalVal, $this);

    if (triggerInput) {
      context.emit('input', externalVal);
      context.emit('update:modelValue', externalVal);
    }
  }; 

  // no export
  const makeExternal = (val) => {
    // If external value should be object
    // no transformation is required
    if (object.value) {
      return val
    }

    // No need to transform if empty value
    if (isNullish(val)) {
      return val
    }

    // If external should be plain transform
    // value object to plain values
    return !Array.isArray(val) ? val[valueProp.value] : val.map(v => v[valueProp.value])
  };

  // no export
  const makeInternal = (val) => {
    if (isNullish(val)) {
      return mode.value === 'single' ? {} : []
    }

    return val
  };

  return {
    update,
  }
}

function useValue (props, context)
{
  const { value, modelValue, mode, valueProp } = toRefs(props);

  // ================ DATA ================

  // internalValue
  const iv = ref(mode.value !== 'single' ? [] : {});

  // ============== COMPUTED ==============

  /* istanbul ignore next */
  // externalValue
  const ev = modelValue && modelValue.value !== undefined ? modelValue : value;

  const plainValue = computed(() => {
    return mode.value === 'single' ? iv.value[valueProp.value] : iv.value.map(v=>v[valueProp.value])
  });

  const textValue = computed(() => {
    return mode.value !== 'single' ? iv.value.map(v=>v[valueProp.value]).join(',') : iv.value[valueProp.value]
  });

  return {
    iv,
    internalValue: iv,
    ev,
    externalValue: ev,
    textValue,
    plainValue,
  }
}

function useSearch (props, context, dep)
{
  const { regex } = toRefs(props);

  const $this = getCurrentInstance().proxy;

  // ============ DEPENDENCIES ============

  const isOpen = dep.isOpen;
  const open = dep.open;

  // ================ DATA ================

  const search = ref(null);

  const input = ref(null);

  // =============== METHODS ==============

  const clearSearch = () => {
    search.value = '';
  };

  const handleSearchInput = (e) => {
    search.value = e.target.value;
  };

  const handleKeypress = (e) => {
    if (regex && regex.value) {
      let regexp = regex.value;

      if (typeof regexp === 'string') {
        regexp = new RegExp(regexp);
      }

      if (!e.key.match(regexp)) {
        e.preventDefault();
      }
    }
  };

  const handlePaste = (e) => {
    if (regex && regex.value) {
      let clipboardData = e.clipboardData || /* istanbul ignore next */ window.clipboardData;
      let pastedData = clipboardData.getData('Text');

      let regexp = regex.value;

      if (typeof regexp === 'string') {
        regexp = new RegExp(regexp);
      }
      
      if (!pastedData.split('').every(c => !!c.match(regexp))) {
        e.preventDefault();
      }
    }

    context.emit('paste', e, $this);
  };

  // ============== WATCHERS ==============

  watch(search, (val) => {
    if (!isOpen.value && val) {
      open();
    }

    context.emit('search-change', val, $this);
  });

  return {
    search,
    input,
    clearSearch,
    handleSearchInput,
    handleKeypress,
    handlePaste,
  }
}

function usePointer$1 (props, context, dep)
{
  const { groupSelect, mode, groups, disabledProp } = toRefs(props);

  // ================ DATA ================

  const pointer = ref(null);

  // =============== METHODS ==============

  const setPointer = (option) => {
    if (option === undefined || (option !== null && option[disabledProp.value])) {
      return
    }

    if (groups.value && option && option.group && (mode.value === 'single' || !groupSelect.value)) {
      return
    }

    pointer.value = option;
  };

  const clearPointer = () => {
    setPointer(null);
  };

  return {
    pointer,
    setPointer,
    clearPointer,
  }
}

function normalize (str, strict = true) {
  return strict
    ? String(str).toLowerCase().trim()
    : String(str).toLowerCase()
                 .normalize('NFD')
                 .trim()
                 .replace(new RegExp(/æ/g), 'ae')
                 .replace(new RegExp(/œ/g), 'oe')
                 .replace(new RegExp(/ø/g), 'o')
                 .replace(/\p{Diacritic}/gu, '')
}

function isObject (variable) {
  return Object.prototype.toString.call(variable) === '[object Object]'
}

function arraysEqual (array1, array2) {
  const array2Sorted = array2.slice().sort();

  return array1.length === array2.length && array1.slice().sort().every(function(value, index) {
      return value === array2Sorted[index];
  })
}

function useOptions (props, context, dep)
{
  const { 
    options, mode, trackBy: trackBy_, limit, hideSelected, createTag, createOption: createOption_, label,
    appendNewTag, appendNewOption: appendNewOption_, multipleLabel, object, loading, delay, resolveOnLoad,
    minChars, filterResults, clearOnSearch, clearOnSelect, valueProp,
    canDeselect, max, strict, closeOnSelect, groups: groupped, reverse, infinite,
    groupOptions, groupHideEmpty, groupSelect, onCreate, disabledProp, searchStart,
  } = toRefs(props);

  const $this = getCurrentInstance().proxy;

  // ============ DEPENDENCIES ============

  const iv = dep.iv;
  const ev = dep.ev;
  const search = dep.search;
  const clearSearch = dep.clearSearch;
  const update = dep.update;
  const pointer = dep.pointer;
  const clearPointer = dep.clearPointer;
  const focus = dep.focus;
  const deactivate = dep.deactivate;
  const close = dep.close;

  // ================ DATA ================

  // no export
  // appendedOptions
  const ap = ref([]);

  // no export
  // resolvedOptions
  const ro = ref([]);

  const resolving = ref(false);

  // no export
  const searchWatcher = ref(null);

  const offset = ref(infinite.value && limit.value === -1 ? 10 : limit.value);

  // ============== COMPUTED ==============

  // no export
  const createOption = computed(() => {
    return createTag.value || createOption_.value || false
  });

  // no export
  const appendNewOption = computed(() => {
    if (appendNewTag.value !== undefined) {
      return appendNewTag.value
    } else if (appendNewOption_.value !== undefined) {
      return appendNewOption_.value
    }

    return true
  });

  // no export
  // extendedOptions
  const eo = computed(() => {
    if (groupped.value) {
      let groups = ro.value || /* istanbul ignore next */ [];

      let eo = [];

      groups.forEach((group) => {
        optionsToArray(group[groupOptions.value]).forEach((option) => {
          eo.push(Object.assign({}, option, group[disabledProp.value] ? { [disabledProp.value]: true } : {}));
        });
      });

      return eo
    } else {
      let eo = optionsToArray(ro.value || /* istanbul ignore next */ []);

      if (ap.value.length) {
        eo = eo.concat(ap.value);
      }

      return eo
    }
  });

  const fg = computed(() => {
    if (!groupped.value) {
      return []
    }

    return filterGroups((ro.value || /* istanbul ignore next */ []).map((group, index) => {
      const arrayOptions = optionsToArray(group[groupOptions.value]);

      return {
        ...group,
        index,
        group: true,
        [groupOptions.value]: filterOptions(arrayOptions, false).map(o => Object.assign({}, o, group[disabledProp.value] ? { [disabledProp.value]: true } : {})),
        __VISIBLE__: filterOptions(arrayOptions).map(o => Object.assign({}, o, group[disabledProp.value] ? { [disabledProp.value]: true } : {})),
      }
      // Difference between __VISIBLE__ and {groupOptions}: visible does not contain selected options when hideSelected=true
    }))
  });

  // preFilteredOptions
  const pfo = computed(() => {
    let options = eo.value;

    if (reverse.value) {
      options = options.reverse();
    }

    if (createdOption.value.length) {
      options = createdOption.value.concat(options);
    }

    return filterOptions(options)
  });

  // filteredOptions
  const fo = computed(() => {
    let options = pfo.value;

    if (offset.value > 0) {
      options = options.slice(0, offset.value);
    }

    return options
  });

  const hasSelected = computed(() => {
    switch (mode.value) {
      case 'single':
        return !isNullish(iv.value[valueProp.value])

      case 'multiple':
      case 'tags':
        return !isNullish(iv.value) && iv.value.length > 0
    }
  });

  const multipleLabelText = computed(() => {
    return multipleLabel !== undefined && multipleLabel.value !== undefined
      ? multipleLabel.value(iv.value, $this)
      : (iv.value && iv.value.length > 1 ? `${iv.value.length} options selected` : `1 option selected`)
  });

  const noOptions = computed(() => {
    return !eo.value.length && !resolving.value && !createdOption.value.length
  });


  const noResults = computed(() => {
    return eo.value.length > 0 && fo.value.length == 0 && ((search.value && groupped.value) || !groupped.value)
  });

  // no export
  const createdOption = computed(() => {
    if (createOption.value === false || !search.value) {
      return []
    }

    return getOptionByTrackBy(search.value) !== -1 ? [] : [{
      [valueProp.value]: search.value,
      [label.value]: search.value,
      [trackBy.value]: search.value,
      __CREATE__: true,
    }]
  });

  const trackBy = computed(() => {
    return trackBy_.value || label.value
  });

  // no export
  const nullValue = computed(() => {
    switch (mode.value) {
      case 'single':
        return null

      case 'multiple':
      case 'tags':
        return []
    }
  });

  const busy = computed(() => {
    return loading.value || resolving.value
  });

  // =============== METHODS ==============

  /**
   * @param {array|object|string|number} option 
   */
  const select = (option) => {
    if (typeof option !== 'object') {
      option = getOption(option);
    }

    switch (mode.value) {
      case 'single':
        update(option);
        break

      case 'multiple':
      case 'tags':
        update((iv.value).concat(option));
        break
    }

    context.emit('select', finalValue(option), option, $this);
  };

  const deselect = (option) => {
    if (typeof option !== 'object') {
      option = getOption(option);
    }

    switch (mode.value) {
      case 'single':
        clear();
        break

      case 'tags':
      case 'multiple':
        update(Array.isArray(option)
          ? iv.value.filter(v => option.map(o => o[valueProp.value]).indexOf(v[valueProp.value]) === -1)
          : iv.value.filter(v => v[valueProp.value] != option[valueProp.value]));
        break
    }

    context.emit('deselect', finalValue(option), option, $this);
  };

  // no export
  const finalValue = (option) => {
    return object.value ? option : option[valueProp.value]
  };

  const remove = (option) => {
    deselect(option);
  };

  const handleTagRemove = (option, e) => {
    if (e.button !== 0) {
      e.preventDefault();
      return
    }

    remove(option);
  };

  const clear = () => {
    context.emit('clear', $this);
    update(nullValue.value);
  };

  const isSelected = (option) => {
    if (option.group !== undefined) {
      return mode.value === 'single' ? false : areAllSelected(option[groupOptions.value]) && option[groupOptions.value].length
    }

    switch (mode.value) {
      case 'single':
        return !isNullish(iv.value) && iv.value[valueProp.value] == option[valueProp.value]

      case 'tags':
      case 'multiple':
        return !isNullish(iv.value) && iv.value.map(o => o[valueProp.value]).indexOf(option[valueProp.value]) !== -1
    }
  };

  const isDisabled = (option) => {
    return option[disabledProp.value] === true
  };

  const isMax = () => {
    if (max === undefined || max.value === -1 || (!hasSelected.value && max.value > 0)) {
      return false
    }
    
    return iv.value.length >= max.value
  };

  const handleOptionClick = (option) => {
    if (isDisabled(option)) {
      return
    }

    if (onCreate && onCreate.value && !isSelected(option) && option.__CREATE__) {
      option = { ...option };
      delete option.__CREATE__;

      option = onCreate.value(option, $this);
      
      if (option instanceof Promise) {
        resolving.value = true;
        option.then((result) => {
          resolving.value = false;
          handleOptionSelect(result);
        });

        return
      } 
    }

    handleOptionSelect(option);
  };

  const handleOptionSelect = (option) => {
    if (option.__CREATE__) {
      option = { ...option };
      delete option.__CREATE__;
    }
    
    switch (mode.value) {
      case 'single':
        if (option && isSelected(option)) {
          if (canDeselect.value) {
            deselect(option);
          }
          return
        }

        if (option) {
          handleOptionAppend(option);
        }

        /* istanbul ignore else */
        if (clearOnSelect.value) {
          clearSearch();
        }

        if (closeOnSelect.value) {
          clearPointer();
          close();
        }

        if (option) {
          select(option);
        }
        break

      case 'multiple':
        if (option && isSelected(option)) {
          deselect(option);
          return
        }

        if (isMax()) {
          context.emit('max', $this);
          return
        }

        if (option) {
          handleOptionAppend(option);
          select(option);
        }

        if (clearOnSelect.value) {
          clearSearch();
        }

        if (hideSelected.value) {
          clearPointer();
        }

        if (closeOnSelect.value) {
          close();
        }
        break

      case 'tags':
        if (option && isSelected(option)) {
          deselect(option);
          return
        }

        if (isMax()) {
          context.emit('max', $this);
          return
        }

        if (option) {
          handleOptionAppend(option);
        }

        if (clearOnSelect.value) {
          clearSearch();
        }

        if (option) {
          select(option);
        }

        if (hideSelected.value) {
          clearPointer();
        }

        if (closeOnSelect.value) {
          close();
        }
        break
    }

    if (!closeOnSelect.value) {
      focus();
    }
  };

  const handleGroupClick = (group) => {
    if (isDisabled(group) || mode.value === 'single' || !groupSelect.value) {
      return
    }

    switch (mode.value) {
      case 'multiple':
      case 'tags':
        if (areAllEnabledSelected(group[groupOptions.value])) {
          deselect(group[groupOptions.value]);
        } else {
          select(group[groupOptions.value]
            .filter(o => iv.value.map(v => v[valueProp.value]).indexOf(o[valueProp.value]) === -1)
            .filter(o => !o[disabledProp.value])
            .filter((o, k) => iv.value.length + 1 + k <= max.value || max.value === -1)
          );
        }
        break
    }

    if (closeOnSelect.value) {
      deactivate();
    }
  };

  const handleOptionAppend = (option) => {
    if (getOption(option[valueProp.value]) === undefined && createOption.value) {
      context.emit('tag', option[valueProp.value], $this);
      context.emit('option', option[valueProp.value], $this);

      if (appendNewOption.value) {
        appendOption(option);
      }

      clearSearch();
    }
  };

  const selectAll = () => {
    if (mode.value === 'single') {
      return
    }

    select(fo.value);
  };

  // no export
  const areAllEnabledSelected = (options) => {
    return options.find(o => !isSelected(o) && !o[disabledProp.value]) === undefined
  };

  // no export
  const areAllSelected = (options) => {
    return options.find(o => !isSelected(o)) === undefined
  };

  const getOption = (val) => {
    return eo.value[eo.value.map(o => String(o[valueProp.value])).indexOf(String(val))]
  };

  // no export
  const getOptionByTrackBy = (val, norm = true) => {
    return eo.value.map(o => parseInt(o[trackBy.value]) == o[trackBy.value] ? parseInt(o[trackBy.value]) : o[trackBy.value]).indexOf(
      parseInt(val) == val ? parseInt(val) : val
    )
  };

  // no export
  const shouldHideOption = (option) => {
    return ['tags', 'multiple'].indexOf(mode.value) !== -1 && hideSelected.value && isSelected(option)
  };

  // no export
  const appendOption = (option) => {
    ap.value.push(option);
  };

  // no export
  const filterGroups = (groups) => {
    // If the search has value we need to filter among 
    // the ones that are visible to the user to avoid
    // displaying groups which technically have options
    // based on search but that option is already selected.
    return groupHideEmpty.value
      ? groups.filter(g => search.value
          ? g.__VISIBLE__.length
          : g[groupOptions.value].length
        )
      : groups.filter(g => search.value ? g.__VISIBLE__.length : true)
  };

  // no export
  const filterOptions = (options, excludeHideSelected = true) => {
    let fo = options;
    
    if (search.value && filterResults.value) {
      fo = fo.filter((option) => {
        return searchStart.value
          ? normalize(option[trackBy.value], strict.value).startsWith(normalize(search.value, strict.value))
          : normalize(option[trackBy.value], strict.value).indexOf(normalize(search.value, strict.value)) !== -1
      });
    }

    if (hideSelected.value && excludeHideSelected) {
      fo = fo.filter((option) => !shouldHideOption(option));
    }

    return fo
  };

  // no export
  const optionsToArray = (options) => {
    let uo = options;
    
    // Transforming an object to an array of objects
    if (isObject(uo)) {
      uo = Object.keys(uo).map((key) => {
        let val = uo[key];

        return { [valueProp.value]: key, [trackBy.value]: val, [label.value]: val}
      });
    }

    // Transforming an plain arrays to an array of objects
    uo = uo.map((val) => {
      return typeof val === 'object' ? val : { [valueProp.value]: val, [trackBy.value]: val, [label.value]: val}
    });

    return uo
  };

  // no export
  const initInternalValue = () => {
    if (!isNullish(ev.value)) {
      iv.value = makeInternal(ev.value);
    }
  };

  const resolveOptions = (callback) => {
    resolving.value = true;

    return new Promise((resolve, reject) => {
      options.value(search.value, $this).then((response) => {
        ro.value = response || [];

        if (typeof callback == 'function') {
          callback(response);
        }

        resolving.value = false;
      }).catch((e) => {
        console.error(e);

        ro.value = [];

        resolving.value = false;
      }).finally(() => {
        resolve();
      });
    })
  };

  // no export
  const refreshLabels = () => {
    if (!hasSelected.value) {
      return
    }

    if (mode.value === 'single') {
      let option = getOption(iv.value[valueProp.value]);

      /* istanbul ignore else */
      if (option !== undefined) {
        let newLabel = option[label.value];

        iv.value[label.value] = newLabel;

        if (object.value) {
          ev.value[label.value] = newLabel;
        }
      }
    } else {
      iv.value.forEach((val, i) => {
        let option = getOption(iv.value[i][valueProp.value]);

        /* istanbul ignore else */
        if (option !== undefined) {
          let newLabel = option[label.value];

          iv.value[i][label.value] = newLabel;

          if (object.value) {
            ev.value[i][label.value] = newLabel;
          }
        }
      });
    }
  };

  const refreshOptions = (callback) => {
    resolveOptions(callback);
  };

  // no export
  const makeInternal = (val) => {
    if (isNullish(val)) {
      return mode.value === 'single' ? {} : []
    }

    if (object.value) {
      return val
    }

    // If external should be plain transform
    // value object to plain values
    return mode.value === 'single' ? getOption(val) || {} : val.filter(v => !! getOption(v)).map(v => getOption(v))
  };

  // no export
  const initSearchWatcher = () => {
    searchWatcher.value = watch(search, (query) => {
      if (query.length < minChars.value || (!query && minChars.value !== 0)) {
        return
      }

      resolving.value = true;

      if (clearOnSearch.value) {
        ro.value = [];
      }
      setTimeout(() => {
        if (query != search.value) {
          return
        }

        options.value(search.value, $this).then((response) => {
          if (query == search.value || !search.value) {
            ro.value = response;
            pointer.value = fo.value.filter(o => o[disabledProp.value] !== true)[0] || null;
            resolving.value = false;
          }
        }).catch( /* istanbul ignore next */ (e) => {
          console.error(e);
        });
      }, delay.value);

    }, { flush: 'sync' });
  };

  // ================ HOOKS ===============

  if (mode.value !== 'single' && !isNullish(ev.value) && !Array.isArray(ev.value)) {
    throw new Error(`v-model must be an array when using "${mode.value}" mode`)
  }

  if (options && typeof options.value == 'function') {
    if (resolveOnLoad.value) {
      resolveOptions(initInternalValue);
    } else if (object.value == true) {
      initInternalValue();
    }
  }
  else {
    ro.value = options.value;

    initInternalValue();
  }
  
  // ============== WATCHERS ==============

  if (delay.value > -1) {
    initSearchWatcher();
  }

  watch(delay, (value, old) => {
    /* istanbul ignore else */
    if (searchWatcher.value) {
      searchWatcher.value();
    }

    if (value >= 0) {
      initSearchWatcher();
    }
  });

  watch(ev, (newValue) => {
    if (isNullish(newValue)) {
      update(makeInternal(newValue), false);
      return
    }

    switch (mode.value) {
      case 'single':
        if (object.value ? newValue[valueProp.value] != iv.value[valueProp.value] : newValue != iv.value[valueProp.value]) {
          update(makeInternal(newValue), false);
        }
        break

      case 'multiple':
      case 'tags':
        if (!arraysEqual(object.value ? newValue.map(o => o[valueProp.value]) : newValue, iv.value.map(o => o[valueProp.value]))) {
          update(makeInternal(newValue), false);
        }
        break
    }
  }, { deep: true });

  watch(options, (n, o) => {
    if (typeof props.options === 'function') {
      if (resolveOnLoad.value && (!o || (n && n.toString() !== o.toString()))) {
        resolveOptions();
      }
    } else {
      ro.value = props.options;

      if (!Object.keys(iv.value).length) {
        initInternalValue();
      }

      refreshLabels();
    }
  });

  watch(label, refreshLabels);

  return {
    pfo,
    fo,
    filteredOptions: fo,
    hasSelected,
    multipleLabelText,
    eo,
    extendedOptions: eo,
    fg,
    filteredGroups: fg,
    noOptions,
    noResults,
    resolving,
    busy,
    offset,
    select,
    deselect,
    remove,
    selectAll,
    clear,
    isSelected,
    isDisabled,
    isMax,
    getOption,
    handleOptionClick,
    handleGroupClick,
    handleTagRemove,
    refreshOptions,
    resolveOptions,
    refreshLabels,
  }
}

function usePointer (props, context, dep)
{
  const {
    valueProp, showOptions, searchable, groupLabel,
    groups: groupped, mode, groupSelect, disabledProp,
  } = toRefs(props);

  // ============ DEPENDENCIES ============

  const fo = dep.fo;
  const fg = dep.fg;
  const handleOptionClick = dep.handleOptionClick;
  const handleGroupClick = dep.handleGroupClick;
  const search = dep.search;
  const pointer = dep.pointer;
  const setPointer = dep.setPointer;
  const clearPointer = dep.clearPointer;
  const multiselect = dep.multiselect;
  const isOpen = dep.isOpen;

  // ============== COMPUTED ==============

  // no export
  const options = computed(() => {
    return fo.value.filter(o => !o[disabledProp.value])
  });

  const groups = computed(() => {
    return fg.value.filter(o => !o[disabledProp.value])
  });

  const canPointGroups = computed(() => {
    return mode.value !== 'single' && groupSelect.value
  });

  const isPointerGroup = computed(() => {
    return pointer.value && pointer.value.group
  });

  const currentGroup = computed(() => {
    return getParentGroup(pointer.value)
  });

  const prevGroup = computed(() => {
    const group = isPointerGroup.value ? pointer.value : /* istanbul ignore next */ getParentGroup(pointer.value);
    const groupIndex = groups.value.map(g => g[groupLabel.value]).indexOf(group[groupLabel.value]);
    let prevGroup = groups.value[groupIndex - 1];

    if (prevGroup === undefined) {
      prevGroup = lastGroup.value;
    }

    return prevGroup
  });
  
  const nextGroup = computed(() => {
    let nextIndex = groups.value.map(g => g.label).indexOf(isPointerGroup.value
      ? pointer.value[groupLabel.value]
      : getParentGroup(pointer.value)[groupLabel.value]) + 1;

    if (groups.value.length <= nextIndex) {
      nextIndex = 0;
    }

    return groups.value[nextIndex]
  });

  const lastGroup = computed(() => {
    return [...groups.value].slice(-1)[0]
  });
  
  const currentGroupFirstEnabledOption = computed(() => {
    return pointer.value.__VISIBLE__.filter(o => !o[disabledProp.value])[0]
  });

  const currentGroupPrevEnabledOption = computed(() => {
    const options = currentGroup.value.__VISIBLE__.filter(o => !o[disabledProp.value]);
    return options[options.map(o => o[valueProp.value]).indexOf(pointer.value[valueProp.value]) - 1]
  });
  
  const currentGroupNextEnabledOption = computed(() => {
    const options = getParentGroup(pointer.value).__VISIBLE__.filter(o => !o[disabledProp.value]);
    return options[options.map(o => o[valueProp.value]).indexOf(pointer.value[valueProp.value]) + 1]
  });

  const prevGroupLastEnabledOption = computed(() => {
    return [...prevGroup.value.__VISIBLE__.filter(o => !o[disabledProp.value])].slice(-1)[0]
  });

  const lastGroupLastEnabledOption = computed(() => {
    return [...lastGroup.value.__VISIBLE__.filter(o => !o[disabledProp.value])].slice(-1)[0]
  });

  // =============== METHODS ==============

  const isPointed = (option) => {
    return (!!pointer.value && (
      (!option.group && pointer.value[valueProp.value] == option[valueProp.value]) ||
      (option.group !== undefined && pointer.value[groupLabel.value] == option[groupLabel.value])
    )) ? true : undefined
  };

  const setPointerFirst = () => {
    setPointer(options.value[0] || null);
  };

  const selectPointer = () => {
    if (!pointer.value || pointer.value[disabledProp.value] === true) {
      return
    }

    if (isPointerGroup.value) {
      handleGroupClick(pointer.value);
    } else {
      handleOptionClick(pointer.value);
    }
  };

  const forwardPointer = () => {
    if (pointer.value === null) {
      setPointer((groupped.value && canPointGroups.value ? groups.value[0] : options.value[0]) || null);
    }
    else if (groupped.value && canPointGroups.value) {
      let nextPointer = isPointerGroup.value ? currentGroupFirstEnabledOption.value : currentGroupNextEnabledOption.value;

      if (nextPointer === undefined) {
        nextPointer = nextGroup.value;
      }

      setPointer(nextPointer || /* istanbul ignore next */ null);
    } else {
      let next = options.value.map(o => o[valueProp.value]).indexOf(pointer.value[valueProp.value]) + 1;

      if (options.value.length <= next) {
        next = 0;
      }

      setPointer(options.value[next] || null);
    }

    nextTick(() => {
      adjustWrapperScrollToPointer();
    });
  };

  const backwardPointer = () => {
    if (pointer.value === null) {
      let prevPointer = options.value[options.value.length - 1];

      if (groupped.value && canPointGroups.value) {
        prevPointer = lastGroupLastEnabledOption.value;

        if (prevPointer === undefined) {
          prevPointer = lastGroup.value;
        }
      }

      setPointer(prevPointer  || null);
    }
    else if (groupped.value && canPointGroups.value) {
      let prevPointer = isPointerGroup.value ? prevGroupLastEnabledOption.value : currentGroupPrevEnabledOption.value;

      if (prevPointer === undefined) {
        prevPointer = isPointerGroup.value ? prevGroup.value : currentGroup.value;
      }

      setPointer(prevPointer || /* istanbul ignore next */ null);
    } else {
      let prevIndex = options.value.map(o => o[valueProp.value]).indexOf(pointer.value[valueProp.value]) - 1;

      if (prevIndex < 0) {
        prevIndex = options.value.length - 1;
      }

      setPointer(options.value[prevIndex] || null);
    }

    nextTick(() => {
      adjustWrapperScrollToPointer();
    });
  };

  const getParentGroup = (option) => {
    return groups.value.find((group) => {
      return group.__VISIBLE__.map(o => o[valueProp.value]).indexOf(option[valueProp.value]) !== -1
    })
  };

  // no export
  /* istanbul ignore next */
  const adjustWrapperScrollToPointer = () => {
    let pointedOption = multiselect.value.querySelector(`[data-pointed]`);

    if (!pointedOption) {
      return
    }

    let wrapper = pointedOption.parentElement.parentElement;

    if (groupped.value) {
      wrapper = isPointerGroup.value
        ? pointedOption.parentElement.parentElement.parentElement
        : pointedOption.parentElement.parentElement.parentElement.parentElement;
    }

    if (pointedOption.offsetTop + pointedOption.offsetHeight > wrapper.clientHeight + wrapper.scrollTop) {
      wrapper.scrollTop = pointedOption.offsetTop + pointedOption.offsetHeight - wrapper.clientHeight;
    }
    
    if (pointedOption.offsetTop < wrapper.scrollTop) {
      wrapper.scrollTop = pointedOption.offsetTop;
    }
  };

  // ============== WATCHERS ==============

  watch(search, (val) => {
    if (searchable.value) {
      if (val.length && showOptions.value) {
        setPointerFirst();
      } else {
        clearPointer();
      }
    }
  });

  watch(isOpen, (val) => {
    if (val) {
      let firstSelected = multiselect.value.querySelectorAll(`[data-selected]`)[0];

      if (!firstSelected) {
        return
      }

      let wrapper = firstSelected.parentElement.parentElement;
      
      nextTick(() => {
        /* istanbul ignore next */
        if (wrapper.scrollTop > 0) {
          return
        }

        wrapper.scrollTop = firstSelected.offsetTop;
      });
    }
  });

  return {
    pointer,
    canPointGroups,
    isPointed,
    setPointerFirst,
    selectPointer,
    forwardPointer,
    backwardPointer,
  }
}

function useDropdown (props, context, dep)
{
  const { disabled } = toRefs(props);

  const $this = getCurrentInstance().proxy;

  // ================ DATA ================

  const isOpen = ref(false);

  // =============== METHODS ==============

  const open = () => {
    if (isOpen.value || disabled.value) {
      return
    }

    isOpen.value = true;
    context.emit('open', $this);
  };

  const close = () => {
    if (!isOpen.value) {
      return
    }

    isOpen.value = false;
    context.emit('close', $this);
  };

  return {
    isOpen,
    open,
    close,
  }
}

function useMultiselect (props, context, dep)
{
  const { searchable, disabled, clearOnBlur } = toRefs(props);

  // ============ DEPENDENCIES ============

  const input = dep.input;
  const open = dep.open;
  const close = dep.close;
  const clearSearch = dep.clearSearch;
  const isOpen = dep.isOpen;

  // ================ DATA ================

  const multiselect = ref(null);
  
  const wrapper = ref(null);

  const tags = ref(null);

  const isActive = ref(false);

  const mouseClicked = ref(false);

  // ============== COMPUTED ==============

  const tabindex = computed(() => {
    return searchable.value || disabled.value ? -1 : 0
  });

  // =============== METHODS ==============

  const blur = () => {
    if (searchable.value) {
      input.value.blur();
    }

    wrapper.value.blur();
  };

  const focus = () => {
    if (searchable.value && !disabled.value) {
      input.value.focus();
    }
  };

  const activate = (shouldOpen = true) => {
    if (disabled.value) {
      return
    }

    isActive.value = true;

    if (shouldOpen) {
      open();
    }
  };

  const deactivate = () => {
    isActive.value = false;

    setTimeout(() => {
      if (!isActive.value) {
        close();

        if (clearOnBlur.value) {
          clearSearch();
        }
      }
    }, 1);
  };

  const handleFocusIn = (e) => {
    if ((e.target.closest('[data-tags]') && e.target.nodeName !== 'INPUT') || e.target.closest('[data-clear]')) {
      return
    }

    activate(mouseClicked.value);
  };

  const handleFocusOut = () => {
    deactivate();
  };

  const handleCaretClick = () => {
    deactivate();
    blur();
  };

  /* istanbul ignore next */
  const handleMousedown = (e) => {
    mouseClicked.value = true;

    if (isOpen.value && (e.target.isEqualNode(wrapper.value) || e.target.isEqualNode(tags.value))) {
      setTimeout(() => {
        deactivate();
      }, 0);
    } else if (document.activeElement.isEqualNode(wrapper.value) && !isOpen.value) {
      activate();    
    }

    setTimeout(() => {
      mouseClicked.value = false;
    }, 0);
  };

  return {
    multiselect,
    wrapper,
    tags,
    tabindex,
    isActive,
    mouseClicked,
    blur,
    focus,
    activate,
    deactivate,
    handleFocusIn,
    handleFocusOut,
    handleCaretClick,
    handleMousedown,
  }
}

function useKeyboard (props, context, dep)
{
  const {
    mode, addTagOn, openDirection, searchable,
    showOptions, valueProp, groups: groupped,
    addOptionOn: addOptionOn_, createTag, createOption: createOption_,
    reverse,
  } = toRefs(props);

  const $this = getCurrentInstance().proxy;

  // ============ DEPENDENCIES ============

  const iv = dep.iv;
  const update = dep.update;
  const search = dep.search;
  const setPointer = dep.setPointer;
  const selectPointer = dep.selectPointer;
  const backwardPointer = dep.backwardPointer;
  const forwardPointer = dep.forwardPointer;
  const multiselect = dep.multiselect;
  const wrapper = dep.wrapper;
  const tags = dep.tags;
  const isOpen = dep.isOpen;
  const open = dep.open;
  const blur = dep.blur;
  const fo = dep.fo;

  // ============== COMPUTED ==============

  // no export
  const createOption = computed(() => {
    return createTag.value || createOption_.value || false
  });

  // no export
  const addOptionOn = computed(() => {
    if (addTagOn.value !== undefined) {
      return addTagOn.value
    }
    else if (addOptionOn_.value !== undefined) {
      return addOptionOn_.value
    }

    return ['enter']
  });

  // =============== METHODS ==============

  // no export
  const preparePointer = () => {
    // When options are hidden and creating tags is allowed
    // no pointer will be set (because options are hidden).
    // In such case we need to set the pointer manually to the 
    // first option, which equals to the option created from
    // the search value.
    if (mode.value === 'tags' && !showOptions.value && createOption.value && searchable.value && !groupped.value) {
      setPointer(fo.value[fo.value.map(o => o[valueProp.value]).indexOf(search.value)]);
    }
  };

  const handleKeydown = (e) => {
    context.emit('keydown', e, $this);

    let tagList;
    let activeIndex;

    if (['ArrowLeft', 'ArrowRight', 'Enter'].indexOf(e.key) !== -1 && mode.value === 'tags') {
      tagList = [...(multiselect.value.querySelectorAll(`[data-tags] > *`))].filter(e => e !== tags.value);
      activeIndex = tagList.findIndex(e => e === document.activeElement);
    }

    switch (e.key) {
      case 'Backspace':
        if (mode.value === 'single') {
          return
        }

        if (searchable.value && [null, ''].indexOf(search.value) === -1) {
          return
        }

        if (iv.value.length === 0) {
          return
        }

        update([...iv.value].slice(0,-1));
        break

      case 'Enter':
        e.preventDefault();

        if (e.keyCode === 229) {
          // ignore IME confirmation
          return
        }

        if (activeIndex !== -1 && activeIndex !== undefined) {
          update([...iv.value].filter((v, k) => k !== activeIndex));

          if (activeIndex === tagList.length - 1) {
            if (tagList.length - 1) {
              tagList[tagList.length - 2].focus();
            } else if (searchable.value) {
              tags.value.querySelector('input').focus();
            } else {
              wrapper.value.focus();
            }
          }
          return
        }

        if (addOptionOn.value.indexOf('enter') === -1 && createOption.value) {
          return
        }
        
        preparePointer();
        selectPointer();
        break

      case ' ':
        if (!createOption.value && !searchable.value) {
          e.preventDefault();
          
          preparePointer();
          selectPointer();
          return
        }

        if (!createOption.value) {
          return false
        } 

        if (addOptionOn.value.indexOf('space') === -1 && createOption.value) {
          return
        }

        e.preventDefault();
        
        preparePointer();
        selectPointer();
        break
      
      case 'Tab':
      case ';':
      case ',':
        if (addOptionOn.value.indexOf(e.key.toLowerCase()) === -1 || !createOption.value) {
          return
        }

        preparePointer();
        selectPointer();
        e.preventDefault();
        break

      case 'Escape':
        blur();
        break

      case 'ArrowUp':
        e.preventDefault();

        if (!showOptions.value) {
          return
        }

        /* istanbul ignore else */
        if (!isOpen.value) {
          open();
        }
        
        backwardPointer();
        break

      case 'ArrowDown':
        e.preventDefault();

        if (!showOptions.value) {
          return
        }

        /* istanbul ignore else */
        if (!isOpen.value) {
          open();
        }

        forwardPointer();
        break

      case 'ArrowLeft':
        if (
          (searchable.value && tags.value && tags.value.querySelector('input').selectionStart)
          || e.shiftKey || mode.value !== 'tags' || !iv.value || !iv.value.length
        ) {
          return
        }

        e.preventDefault();

        if (activeIndex === -1) {
          tagList[tagList.length-1].focus();
        }
        else if (activeIndex > 0) {
          tagList[activeIndex-1].focus();
        }
        break

      case 'ArrowRight':
        if (activeIndex === -1 || e.shiftKey || mode.value !== 'tags' || !iv.value || !iv.value.length) {
          return
        }

        e.preventDefault();
        
        /* istanbul ignore else */
        if (tagList.length > activeIndex + 1) {
          tagList[activeIndex+1].focus();
        }
        else if (searchable.value) {
          tags.value.querySelector('input').focus();
        }
        else if (!searchable.value) {
          wrapper.value.focus();
        }
        
        break
    }
  };

  const handleKeyup = (e) => {
    context.emit('keyup', e, $this);
  };

  return {
    handleKeydown,
    handleKeyup,
    preparePointer,
  }
}

function useClasses (props, context, dependencies)
{const { 
    classes: classes_, disabled, openDirection, showOptions
  } = toRefs(props);

  // ============ DEPENDENCIES ============

  const isOpen = dependencies.isOpen;
  const isPointed = dependencies.isPointed;
  const isSelected = dependencies.isSelected;
  const isDisabled = dependencies.isDisabled;
  const isActive = dependencies.isActive;
  const canPointGroups = dependencies.canPointGroups;
  const resolving = dependencies.resolving;
  const fo = dependencies.fo;

  const classes = computed(() => ({
    container: 'multiselect',
    containerDisabled: 'is-disabled',
    containerOpen: 'is-open',
    containerOpenTop: 'is-open-top',
    containerActive: 'is-active',
    wrapper: 'multiselect-wrapper',
    singleLabel: 'multiselect-single-label',
    singleLabelText: 'multiselect-single-label-text',
    multipleLabel: 'multiselect-multiple-label',
    search: 'multiselect-search',
    tags: 'multiselect-tags',
    tag: 'multiselect-tag',
    tagDisabled: 'is-disabled',
    tagRemove: 'multiselect-tag-remove',
    tagRemoveIcon: 'multiselect-tag-remove-icon',
    tagsSearchWrapper: 'multiselect-tags-search-wrapper',
    tagsSearch: 'multiselect-tags-search',
    tagsSearchCopy: 'multiselect-tags-search-copy',
    placeholder: 'multiselect-placeholder',
    caret: 'multiselect-caret',
    caretOpen: 'is-open',
    clear: 'multiselect-clear',
    clearIcon: 'multiselect-clear-icon',
    spinner: 'multiselect-spinner',
    inifinite: 'multiselect-inifite',
    inifiniteSpinner: 'multiselect-inifite-spinner',
    dropdown: 'multiselect-dropdown',
    dropdownTop: 'is-top',
    dropdownHidden: 'is-hidden',
    options: 'multiselect-options',
    optionsTop: 'is-top',
    group: 'multiselect-group',
    groupLabel: 'multiselect-group-label',
    groupLabelPointable: 'is-pointable',
    groupLabelPointed: 'is-pointed',
    groupLabelSelected: 'is-selected',
    groupLabelDisabled: 'is-disabled',
    groupLabelSelectedPointed: 'is-selected is-pointed',
    groupLabelSelectedDisabled: 'is-selected is-disabled',
    groupOptions: 'multiselect-group-options',
    option: 'multiselect-option',
    optionPointed: 'is-pointed',
    optionSelected: 'is-selected',
    optionDisabled: 'is-disabled',
    optionSelectedPointed: 'is-selected is-pointed',
    optionSelectedDisabled: 'is-selected is-disabled',
    noOptions: 'multiselect-no-options',
    noResults: 'multiselect-no-results',
    fakeInput: 'multiselect-fake-input',
    assist: 'multiselect-assistive-text',
    spacer: 'multiselect-spacer',
    ...classes_.value,
  }));

  // ============== COMPUTED ==============

  const showDropdown = computed(() => {
    return !!(isOpen.value && showOptions.value && (!resolving.value || (resolving.value && fo.value.length)))
  });

  const classList = computed(() => {
    const c = classes.value;

    return {
      container: [c.container]
        .concat(disabled.value ? c.containerDisabled : [])
        .concat(showDropdown.value && openDirection.value === 'top'  ? c.containerOpenTop : [])
        .concat(showDropdown.value && openDirection.value !== 'top' ? c.containerOpen : [])
        .concat(isActive.value ? c.containerActive : []),
      wrapper: c.wrapper,
      spacer: c.spacer,
      singleLabel: c.singleLabel,
      singleLabelText: c.singleLabelText,
      multipleLabel: c.multipleLabel,
      search: c.search,
      tags: c.tags,
      tag: [c.tag]
        .concat(disabled.value ? c.tagDisabled : []),
      tagRemove: c.tagRemove,
      tagRemoveIcon: c.tagRemoveIcon,
      tagsSearchWrapper: c.tagsSearchWrapper,
      tagsSearch: c.tagsSearch,
      tagsSearchCopy: c.tagsSearchCopy,
      placeholder: c.placeholder,
      caret: [c.caret]
        .concat(isOpen.value ? c.caretOpen : []),
      clear: c.clear,
      clearIcon: c.clearIcon,
      spinner: c.spinner,
      inifinite: c.inifinite,
      inifiniteSpinner: c.inifiniteSpinner,
      dropdown: [c.dropdown]
        .concat(openDirection.value === 'top' ? c.dropdownTop : [])
        .concat(!isOpen.value || !showOptions.value || !showDropdown.value ? c.dropdownHidden : []),
      options: [c.options]
        .concat(openDirection.value === 'top' ? c.optionsTop : []),
      group: c.group,
      groupLabel: (g) => {
        let groupLabel = [c.groupLabel];

        if (isPointed(g)) {
          groupLabel.push(isSelected(g) ? c.groupLabelSelectedPointed : c.groupLabelPointed);
        } else if (isSelected(g) && canPointGroups.value) {
          groupLabel.push(isDisabled(g) ? c.groupLabelSelectedDisabled : c.groupLabelSelected);
        } else if (isDisabled(g)) {
          groupLabel.push(c.groupLabelDisabled);
        }

        if (canPointGroups.value) {
          groupLabel.push(c.groupLabelPointable);
        }

        return groupLabel
      },
      groupOptions: c.groupOptions,
      option: (o, g) => {
        let option = [c.option];

        if (isPointed(o)) {
          option.push(isSelected(o) ? c.optionSelectedPointed : c.optionPointed);
        } else if (isSelected(o)) {
          option.push(isDisabled(o) ? c.optionSelectedDisabled : c.optionSelected);
        } else if (isDisabled(o) || (g && isDisabled(g))) {
          option.push(c.optionDisabled);
        }

        return option
      },
      noOptions: c.noOptions,
      noResults: c.noResults,
      assist: c.assist,
      fakeInput: c.fakeInput,
    }
  });

  return {
    classList,
    showDropdown,
  }
}

function useScroll$1 (props, context, dep)
{
  const {
    limit, infinite,
  } = toRefs(props);

  // ============ DEPENDENCIES ============

  const isOpen = dep.isOpen;
  const offset = dep.offset;
  const search = dep.search;
  const pfo = dep.pfo;
  const eo = dep.eo;

  // ================ DATA ================

  // no export
  const observer = ref(null);

  const infiniteLoader = ref(null);

  // ============== COMPUTED ==============

  const hasMore = computed(() => {
    return offset.value < pfo.value.length
  });

  // =============== METHODS ==============

  // no export
  /* istanbul ignore next */
  const handleIntersectionObserver = (entries) => {
    const { isIntersecting, target } = entries[0];

    if (isIntersecting) {
      const parent = target.offsetParent;
      const scrollTop = parent.scrollTop;

      offset.value += limit.value == -1 ? 10 : limit.value;

      nextTick(() => {
        parent.scrollTop = scrollTop;
      });
    }
  };

  const observe = () => {
    /* istanbul ignore else */
    if (isOpen.value && offset.value < pfo.value.length) {
      observer.value.observe(infiniteLoader.value);
    } else if (!isOpen.value && observer.value) {
      observer.value.disconnect();
    }
  };

  // ============== WATCHERS ==============

  watch(isOpen, () => {
    if (!infinite.value) {
      return
    }

    observe();
  });

  watch(search, () => {
    if (!infinite.value) {
      return
    }

    offset.value = limit.value;

    observe();
  }, { flush: 'post' });

  watch(eo, () => {
    if (!infinite.value) {
      return
    }

    observe();
  }, { immediate: false, flush: 'post' });

  // ================ HOOKS ===============

  onMounted(() => {
    /* istanbul ignore else */
    if (window && window.IntersectionObserver) {
      observer.value = new IntersectionObserver(handleIntersectionObserver);
    }
  });

  return {
    hasMore,
    infiniteLoader,
  }
}

function useScroll (props, context, dep)
{
  const {
    placeholder, id, valueProp, label: labelProp, mode, groupLabel, aria, searchable ,
  } = toRefs(props);

  // ============ DEPENDENCIES ============

  const pointer = dep.pointer;
  const iv = dep.iv;
  const hasSelected = dep.hasSelected;
  const multipleLabelText = dep.multipleLabelText;

  // ================ DATA ================

  const label = ref(null);

  // ============== COMPUTED ==============

  const ariaAssist = computed(() => {
    let texts = [];

    if (id && id.value) {
      texts.push(id.value);
    }

    texts.push('assist');

    return texts.join('-')
  });

  const ariaControls = computed(() => {
    let texts = [];

    if (id && id.value) {
      texts.push(id.value);
    }

    texts.push('multiselect-options');

    return texts.join('-')
  });

  const ariaActiveDescendant = computed(() => {
    let texts = [];

    if (id && id.value) {
      texts.push(id.value);
    }

    if (pointer.value) {
      texts.push(pointer.value.group ? 'multiselect-group' : 'multiselect-option');

      texts.push(pointer.value.group ? pointer.value.index : pointer.value[valueProp.value]);

      return texts.join('-')
    }
  });



  const ariaPlaceholder = computed(() => {
    return placeholder.value
  });

  const ariaMultiselectable = computed(() => {
    return mode.value !== 'single'
  });

  const ariaLabel = computed(() => {
    let ariaLabel = '';

    if (mode.value === 'single' && hasSelected.value) {
      ariaLabel += iv.value[labelProp.value];
    }

    if (mode.value === 'multiple' && hasSelected.value) {
      ariaLabel += multipleLabelText.value;
    }

    if (mode.value === 'tags' && hasSelected.value) {
      ariaLabel += iv.value.map(v => v[labelProp.value]).join(', ');
    }

    return ariaLabel
  });

  const arias = computed(() => {
    let arias = { ...aria.value };
    
    // Need to add manually because focusing
    // the input won't read the selected value
    if (searchable.value) {
      arias['aria-labelledby'] = arias['aria-labelledby']
        ? `${ariaAssist.value} ${arias['aria-labelledby']}`
        : ariaAssist.value;
      
      if (ariaLabel.value && arias['aria-label']) {
        arias['aria-label'] = `${ariaLabel.value}, ${arias['aria-label']}`;
      }
    }

    return arias
  });

  // =============== METHODS ==============

  const ariaOptionId = (option) => {
    let texts = [];

    if (id && id.value) {
      texts.push(id.value);
    }

    texts.push('multiselect-option');

    texts.push(option[valueProp.value]);

    return texts.join('-')
  };

  const ariaGroupId = (option) => {
    let texts = [];

    if (id && id.value) {
      texts.push(id.value);
    }

    texts.push('multiselect-group');

    texts.push(option.index);

    return texts.join('-')
  };

  const ariaOptionLabel = (option) => {
    let texts = [];

    texts.push(option[labelProp.value]);

    return texts.join(' ')
  };

  const ariaGroupLabel = (group) => {
    let texts = [];

    texts.push(group[groupLabel.value]);

    return texts.join(' ')
  };

  const ariaTagLabel = (label) => {
    return `${label} ❎`
  };

  // =============== HOOKS ================

  onMounted(() => {
    /* istanbul ignore next */
    if (id && id.value && document && document.querySelector) {
      let forTag = document.querySelector(`[for="${id.value}"]`);
      label.value = forTag ? forTag.innerText : null;
    }
  });

  return {
    arias,
    ariaLabel,
    ariaAssist,
    ariaControls,
    ariaPlaceholder,
    ariaMultiselectable,
    ariaActiveDescendant,
    ariaOptionId,
    ariaOptionLabel,
    ariaGroupId,
    ariaGroupLabel,
    ariaTagLabel,
  }
}

function resolveDeps (props, context, features, deps = {}) {
  features.forEach((composable) => {
    /* istanbul ignore else */
    if (composable) {
      deps = {
        ...deps,
        ...composable(props, context, deps)
      };
    }

  });
  
  return deps
}

//

  var script$7 = {
    name: 'Multiselect',
    emits: [
      'paste', 'open', 'close', 'select', 'deselect', 
      'input', 'search-change', 'tag', 'option', 'update:modelValue',
      'change', 'clear', 'keydown', 'keyup', 'max',
    ],
    props: {
      value: {
        required: false,
      },
      modelValue: {
        required: false,
      },
      options: {
        type: [Array, Object, Function],
        required: false,
        default: () => ([])
      },
      id: {
        type: [String, Number],
        required: false,
      },
      name: {
        type: [String, Number],
        required: false,
        default: 'multiselect',
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      label: {
        type: String,
        required: false,
        default: 'label',
      },
      trackBy: {
        type: String,
        required: false,
        default: undefined,
      },
      valueProp: {
        type: String,
        required: false,
        default: 'value',
      },
      placeholder: {
        type: String,
        required: false,
        default: null,
      },
      mode: {
        type: String,
        required: false,
        default: 'single', // single|multiple|tags
      },
      searchable: {
        type: Boolean,
        required: false,
        default: false,
      },
      limit: {
        type: Number,
        required: false,
        default: -1,
      },
      hideSelected: {
        type: Boolean,
        required: false,
        default: true,
      },
      createTag: {
        type: Boolean,
        required: false,
        default: undefined,
      },
      createOption: {
        type: Boolean,
        required: false,
        default: undefined,
      },
      appendNewTag: {
        type: Boolean,
        required: false,
        default: undefined,
      },
      appendNewOption: {
        type: Boolean,
        required: false,
        default: undefined,
      },
      addTagOn: {
        type: Array,
        required: false,
        default: undefined,
      },
      addOptionOn: {
        type: Array,
        required: false,
        default: undefined,
      },
      caret: {
        type: Boolean,
        required: false,
        default: true,
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
      noOptionsText: {
        type: String,
        required: false,
        default: 'The list is empty',
      },
      noResultsText: {
        type: String,
        required: false,
        default: 'No results found',
      },
      multipleLabel: {
        type: Function,
        required: false,
      },
      object: {
        type: Boolean,
        required: false,
        default: false,
      },
      delay: {
        type: Number,
        required: false,
        default: -1,
      },
      minChars: {
        type: Number,
        required: false,
        default: 0,
      },
      resolveOnLoad: {
        type: Boolean,
        required: false,
        default: true,
      },
      filterResults: {
        type: Boolean,
        required: false,
        default: true,
      },
      clearOnSearch: {
        type: Boolean,
        required: false,
        default: false,
      },
      clearOnSelect: {
        type: Boolean,
        required: false,
        default: true,
      },
      canDeselect: {
        type: Boolean,
        required: false,
        default: true,
      },
      canClear: {
        type: Boolean,
        required: false,
        default: true,
      },
      max: {
        type: Number,
        required: false,
        default: -1,
      },
      showOptions: {
        type: Boolean,
        required: false,
        default: true,
      },
      required: {
        type: Boolean,
        required: false,
        default: false,
      },
      openDirection: {
        type: String,
        required: false,
        default: 'bottom',
      },
      nativeSupport: {
        type: Boolean,
        required: false,
        default: false,
      },
      classes: {
        type: Object,
        required: false,
        default: () => ({})
      },
      strict: {
        type: Boolean,
        required: false,
        default: true,
      },
      closeOnSelect: {
        type: Boolean,
        required: false,
        default: true,
      },
      autocomplete: {
        type: String,
        required: false,
      },
      groups: {
        type: Boolean,
        required: false,
        default: false,
      },
      groupLabel: {
        type: String,
        required: false,
        default: 'label',
      },
      groupOptions: {
        type: String,
        required: false,
        default: 'options',
      },
      groupHideEmpty: {
        type: Boolean,
        required: false,
        default: false,
      },
      groupSelect: {
        type: Boolean,
        required: false,
        default: true,
      },
      inputType: {
        type: String,
        required: false,
        default: 'text',
      },
      attrs: {
        required: false,
        type: Object,
        default: () => ({}),
      },
      onCreate: {
        required: false,
        type: Function,
      },
      disabledProp: {
        type: String,
        required: false,
        default: 'disabled',
      },
      searchStart: {
        type: Boolean,
        required: false,
        default: false,
      },
      reverse: {
        type: Boolean,
        required: false,
        default: false,
      },
      regex: {
        type: [Object, String, RegExp],
        required: false,
        default: undefined,
      },
      rtl: {
        type: Boolean,
        required: false,
        default: false,
      },
      infinite: {
        type: Boolean,
        required: false,
        default: false,
      },
      aria: {
        required: false,
        type: Object,
        default: () => ({}),
      },
      clearOnBlur: {
        required: false,
        type: Boolean,
        default: true,
      },
    },
    setup(props, context)
    { 
      return resolveDeps(props, context, [
        useValue,
        usePointer$1,
        useDropdown,
        useSearch,
        useData,
        useMultiselect,
        useOptions,
        useScroll$1,
        usePointer,
        useKeyboard,
        useClasses,
        useScroll,
      ])
    }
  };

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      ref: "multiselect",
      class: _vm.classList.container,
      attrs: {
        id: _vm.searchable ? undefined : _vm.id,
        dir: _vm.rtl ? "rtl" : undefined,
      },
      on: {
        focusin: _vm.handleFocusIn,
        focusout: _vm.handleFocusOut,
        keyup: _vm.handleKeyup,
        keydown: _vm.handleKeydown,
      },
    },
    [
      _c(
        "div",
        _vm._b(
          {
            ref: "wrapper",
            class: _vm.classList.wrapper,
            attrs: {
              tabindex: _vm.tabindex,
              "aria-controls": !_vm.searchable ? _vm.ariaControls : undefined,
              "aria-placeholder": !_vm.searchable
                ? _vm.ariaPlaceholder
                : undefined,
              "aria-expanded": !_vm.searchable ? _vm.isOpen : undefined,
              "aria-activedescendant": !_vm.searchable
                ? _vm.ariaActiveDescendant
                : undefined,
              "aria-multiselectable": !_vm.searchable
                ? _vm.ariaMultiselectable
                : undefined,
              role: !_vm.searchable ? "combobox" : undefined,
            },
            on: { mousedown: _vm.handleMousedown },
          },
          "div",
          !_vm.searchable ? _vm.arias : {},
          false
        ),
        [
          _vm.mode !== "tags" && _vm.searchable && !_vm.disabled
            ? [
                _c(
                  "input",
                  _vm._b(
                    {
                      ref: "input",
                      class: _vm.classList.search,
                      attrs: {
                        type: _vm.inputType,
                        modelValue: _vm.search,
                        autocomplete: _vm.autocomplete,
                        id: _vm.searchable ? _vm.id : undefined,
                        "aria-controls": _vm.ariaControls,
                        "aria-placeholder": _vm.ariaPlaceholder,
                        "aria-expanded": _vm.isOpen,
                        "aria-activedescendant": _vm.ariaActiveDescendant,
                        "aria-multiselectable": _vm.ariaMultiselectable,
                        role: "combobox",
                      },
                      domProps: { value: _vm.search },
                      on: {
                        input: _vm.handleSearchInput,
                        keypress: _vm.handleKeypress,
                        paste: function ($event) {
                          $event.stopPropagation();
                          return _vm.handlePaste.apply(null, arguments)
                        },
                      },
                    },
                    "input",
                    Object.assign({}, _vm.attrs, _vm.arias),
                    false
                  )
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.mode == "tags"
            ? [
                _c(
                  "div",
                  { class: _vm.classList.tags, attrs: { "data-tags": "" } },
                  [
                    _vm._l(_vm.iv, function (option, i, key) {
                      return _vm._t(
                        "tag",
                        function () {
                          return [
                            _c(
                              "span",
                              {
                                key: key,
                                class: _vm.classList.tag,
                                attrs: {
                                  tabindex: "-1",
                                  "aria-label": _vm.ariaTagLabel(
                                    option[_vm.label]
                                  ),
                                },
                                on: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleTagRemove(option, $event)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(option[_vm.label]) +
                                    "\n            "
                                ),
                                !_vm.disabled
                                  ? _c(
                                      "span",
                                      {
                                        class: _vm.classList.tagRemove,
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation();
                                            return _vm.handleTagRemove(
                                              option,
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("span", {
                                          class: _vm.classList.tagRemoveIcon,
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        },
                        {
                          option: option,
                          handleTagRemove: _vm.handleTagRemove,
                          disabled: _vm.disabled,
                        }
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { ref: "tags", class: _vm.classList.tagsSearchWrapper },
                      [
                        _c("span", { class: _vm.classList.tagsSearchCopy }, [
                          _vm._v(_vm._s(_vm.search)),
                        ]),
                        _vm._v(" "),
                        _vm.searchable && !_vm.disabled
                          ? _c(
                              "input",
                              _vm._b(
                                {
                                  ref: "input",
                                  class: _vm.classList.tagsSearch,
                                  attrs: {
                                    type: _vm.inputType,
                                    modelValue: _vm.search,
                                    id: _vm.searchable ? _vm.id : undefined,
                                    autocomplete: _vm.autocomplete,
                                    "aria-controls": _vm.ariaControls,
                                    "aria-placeholder": _vm.ariaPlaceholder,
                                    "aria-expanded": _vm.isOpen,
                                    "aria-activedescendant":
                                      _vm.ariaActiveDescendant,
                                    "aria-multiselectable":
                                      _vm.ariaMultiselectable,
                                    role: "combobox",
                                  },
                                  domProps: { value: _vm.search },
                                  on: {
                                    input: _vm.handleSearchInput,
                                    keypress: _vm.handleKeypress,
                                    paste: function ($event) {
                                      $event.stopPropagation();
                                      return _vm.handlePaste.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                "input",
                                Object.assign({}, _vm.attrs, _vm.arias),
                                false
                              )
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  2
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.mode == "single" && _vm.hasSelected && !_vm.search && _vm.iv
            ? [
                _vm._t(
                  "singlelabel",
                  function () {
                    return [
                      _c("div", { class: _vm.classList.singleLabel }, [
                        _c("span", { class: _vm.classList.singleLabelText }, [
                          _vm._v(_vm._s(_vm.iv[_vm.label])),
                        ]),
                      ]),
                    ]
                  },
                  { value: _vm.iv }
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.mode == "multiple" && _vm.hasSelected && !_vm.search
            ? [
                _vm._t(
                  "multiplelabel",
                  function () {
                    return [
                      _c("div", {
                        class: _vm.classList.multipleLabel,
                        domProps: { innerHTML: _vm._s(_vm.multipleLabelText) },
                      }),
                    ]
                  },
                  { values: _vm.iv }
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.placeholder && !_vm.hasSelected && !_vm.search
            ? [
                _vm._t("placeholder", function () {
                  return [
                    _c(
                      "div",
                      {
                        class: _vm.classList.placeholder,
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.placeholder) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.loading || _vm.resolving
            ? _vm._t("spinner", function () {
                return [
                  _c("span", {
                    class: _vm.classList.spinner,
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasSelected && !_vm.disabled && _vm.canClear && !_vm.busy
            ? _vm._t(
                "clear",
                function () {
                  return [
                    _c(
                      "span",
                      {
                        class: _vm.classList.clear,
                        attrs: {
                          "aria-hidden": "true",
                          tabindex: "0",
                          role: "button",
                          "data-clear": "",
                          "aria-roledescription": "❎",
                        },
                        on: {
                          click: _vm.clear,
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.clear.apply(null, arguments)
                          },
                        },
                      },
                      [_c("span", { class: _vm.classList.clearIcon })]
                    ),
                  ]
                },
                { clear: _vm.clear }
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.caret && _vm.showOptions
            ? _vm._t("caret", function () {
                return [
                  _c("span", {
                    class: _vm.classList.caret,
                    attrs: { "aria-hidden": "true" },
                    on: { click: _vm.handleCaretClick },
                  }),
                ]
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.classList.dropdown, attrs: { tabindex: "-1" } },
        [
          _vm._t("beforelist", null, { options: _vm.fo }),
          _vm._v(" "),
          _c(
            "ul",
            {
              class: _vm.classList.options,
              attrs: { id: _vm.ariaControls, role: "listbox" },
            },
            [
              _vm.groups
                ? _vm._l(_vm.fg, function (group, i, key) {
                    return _c(
                      "li",
                      {
                        key: key,
                        class: _vm.classList.group,
                        attrs: {
                          id: _vm.ariaGroupId(group),
                          "aria-label": _vm.ariaGroupLabel(group),
                          "aria-selected": _vm.isSelected(group),
                          role: "option",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            class: _vm.classList.groupLabel(group),
                            attrs: { "data-pointed": _vm.isPointed(group) },
                            on: {
                              mouseenter: function ($event) {
                                return _vm.setPointer(group, i)
                              },
                              click: function ($event) {
                                return _vm.handleGroupClick(group)
                              },
                            },
                          },
                          [
                            _vm._t(
                              "grouplabel",
                              function () {
                                return [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(group[_vm.groupLabel]),
                                    },
                                  }),
                                ]
                              },
                              {
                                group: group,
                                isSelected: _vm.isSelected,
                                isPointed: _vm.isPointed,
                              }
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            class: _vm.classList.groupOptions,
                            attrs: {
                              "aria-label": _vm.ariaGroupLabel(group),
                              role: "group",
                            },
                          },
                          _vm._l(group.__VISIBLE__, function (option, i, key) {
                            return _c(
                              "li",
                              {
                                key: key,
                                class: _vm.classList.option(option, group),
                                attrs: {
                                  "data-pointed": _vm.isPointed(option),
                                  "data-selected":
                                    _vm.isSelected(option) || undefined,
                                  id: _vm.ariaOptionId(option),
                                  "aria-selected": _vm.isSelected(option),
                                  "aria-label": _vm.ariaOptionLabel(option),
                                  role: "option",
                                },
                                on: {
                                  mouseenter: function ($event) {
                                    return _vm.setPointer(option)
                                  },
                                  click: function ($event) {
                                    return _vm.handleOptionClick(option)
                                  },
                                },
                              },
                              [
                                _vm._t(
                                  "option",
                                  function () {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(option[_vm.label])),
                                      ]),
                                    ]
                                  },
                                  {
                                    option: option,
                                    isSelected: _vm.isSelected,
                                    isPointed: _vm.isPointed,
                                    search: _vm.search,
                                  }
                                ),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  })
                : _vm._l(_vm.fo, function (option, i, key) {
                    return _c(
                      "li",
                      {
                        key: key,
                        class: _vm.classList.option(option),
                        attrs: {
                          "data-pointed": _vm.isPointed(option),
                          "data-selected": _vm.isSelected(option) || undefined,
                          id: _vm.ariaOptionId(option),
                          "aria-selected": _vm.isSelected(option),
                          "aria-label": _vm.ariaOptionLabel(option),
                          role: "option",
                        },
                        on: {
                          mouseenter: function ($event) {
                            return _vm.setPointer(option)
                          },
                          click: function ($event) {
                            return _vm.handleOptionClick(option)
                          },
                        },
                      },
                      [
                        _vm._t(
                          "option",
                          function () {
                            return [
                              _c("span", [_vm._v(_vm._s(option[_vm.label]))]),
                            ]
                          },
                          {
                            option: option,
                            isSelected: _vm.isSelected,
                            isPointed: _vm.isPointed,
                            search: _vm.search,
                          }
                        ),
                      ],
                      2
                    )
                  }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.noOptions
            ? _vm._t("nooptions", function () {
                return [
                  _c("div", {
                    class: _vm.classList.noOptions,
                    domProps: { innerHTML: _vm._s(_vm.noOptionsText) },
                  }),
                ]
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.noResults
            ? _vm._t("noresults", function () {
                return [
                  _c("div", {
                    class: _vm.classList.noResults,
                    domProps: { innerHTML: _vm._s(_vm.noResultsText) },
                  }),
                ]
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.infinite && _vm.hasMore
            ? _c(
                "div",
                { ref: "infiniteLoader", class: _vm.classList.inifinite },
                [
                  _vm._t("infinite", function () {
                    return [
                      _c("span", { class: _vm.classList.inifiniteSpinner }),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("afterlist", null, { options: _vm.fo }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.required
        ? _c("input", {
            class: _vm.classList.fakeInput,
            attrs: { tabindex: "-1", required: "" },
            domProps: { value: _vm.textValue },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.nativeSupport
        ? [
            _vm.mode == "single"
              ? _c("input", {
                  attrs: { type: "hidden", name: _vm.name },
                  domProps: {
                    value: _vm.plainValue !== undefined ? _vm.plainValue : "",
                  },
                })
              : _vm._l(_vm.plainValue, function (v, i) {
                  return _c("input", {
                    key: i,
                    attrs: { type: "hidden", name: _vm.name + "[]" },
                    domProps: { value: v },
                  })
                }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.searchable && _vm.hasSelected
        ? _c(
            "div",
            {
              class: _vm.classList.assist,
              attrs: { id: _vm.ariaAssist, "aria-hidden": "true" },
            },
            [_vm._v("\n    " + _vm._s(_vm.ariaLabel) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: _vm.classList.spacer }),
    ],
    2
  )
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  const __vue_inject_styles__$7 = undefined;
  /* scoped */
  const __vue_scope_id__$7 = undefined;
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    undefined,
    undefined,
    undefined
  );

var script$6 = defineComponent({
  name: 'SearchSelect',
  components: {
    VMultiselect: __vue_component__$7
  },
  emits: ['update:modelValue', 'update:searchValue'],
  props: {
    modelValue: {
      type: [Object, Array]
    },
    options: {
      type: [Array, Function],
      required: true
    },
    displayProp: {
      type: String,
      required: true
    },
    valueProp: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    required: {
      type: Boolean,
      default: () => true
    },
    searchable: {
      type: Boolean,
      default: () => true
    },
    minChars: {
      type: Number,
      default: () => 1
    },
    noOptionsText: {
      type: String,
      default: () => 'No matching results'
    },
    noResultsText: {
      type: String,
      default: () => 'No matching results'
    },
    clearOnSearch: {
      type: Boolean,
      default: () => false
    },
    clearOnSelect: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    canClear: {
      type: Boolean,
      default: () => true
    },
    resolveOnLoad: {
      type: Boolean,
      default: () => false
    },
    allowAddnew: {
      type: Boolean,
      default: () => true
    },
    openDirection: {
      type: String,
      default: () => 'bottom' // or 'top'
    },

    closeOnSelect: {
      type: Boolean,
      default: () => true
    },
    internalSearch: {
      type: Boolean,
      default: () => true
    },
    showNoResults: {
      type: Boolean,
      default: () => true
    },
    hideSelected: {
      type: Boolean,
      default: () => false
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    mode: {
      type: String,
      default: () => 'single'
    },
    id: {
      type: String,
      default: () => 'multiselect'
    },
    createOption: {
      type: Boolean,
      default: () => false
    },
    dataTestIdString: {
      type: String,
      required: false
    }
  },
  setup(props, {
    emit
  }) {
    const multiselectRef = ref();
    const asyncMode = !!props.options && !Array.isArray(props.options);
    const change = newSelectionValue => {
      emit('update:modelValue', newSelectionValue);
    };
    const handleSearchChange = query => {
      emit('update:searchValue', query);
    };
    const componentModelObject = ref(props.modelValue);
    const clear = () => {
      if (componentModelObject.value) {
        multiselectRef.value.deselect(componentModelObject.value);
      }
    };
    const refreshOptions = async () => multiselectRef.value.refreshOptions();
    const open = () => multiselectRef.value.open();
    const close = () => multiselectRef.value.close();
    const select = obj => multiselectRef.value.select(obj);
    const focus = () => multiselectRef.value.focus();
    return {
      asyncMode,
      change,
      clear,
      open,
      close,
      select,
      focus,
      componentModelObject,
      multiselectRef,
      handleSearchChange,
      refreshOptions
    };
  },
  watch: {
    modelValue(newModelValue) {
      this.componentModelObject = newModelValue;
    }
  }
});

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('VMultiselect', {
    ref: "multiselectRef",
    class: {
      'border-danger': _vm.required && (!_vm.componentModelObject || !_vm.componentModelObject[_vm.valueProp]),
      'normal-font': true
    },
    attrs: {
      "options": _vm.options,
      "label": _vm.displayProp,
      "trackBy": _vm.displayProp,
      "searchable": _vm.searchable,
      "noOptionsText": _vm.noOptionsText,
      "noResultsText": _vm.noResultsText,
      "clearOnSearch": _vm.clearOnSearch,
      "delay": _vm.asyncMode ? 100 : -1,
      "placeholder": _vm.placeholder,
      "valueProp": _vm.valueProp,
      "minChars": _vm.minChars,
      "object": true,
      "disabled": _vm.disabled,
      "canDeselect": false,
      "canClear": _vm.canClear,
      "resolveOnLoad": _vm.resolveOnLoad,
      "internalSearch": _vm.internalSearch,
      "showNoResults": _vm.showNoResults,
      "loading": _vm.loading,
      "required": _vm.required,
      "clearOnSelect": _vm.clearOnSelect,
      "closeOnSelect": _vm.closeOnSelect,
      "openDirection": _vm.openDirection,
      "mode": _vm.mode,
      "id": _vm.id,
      "createOption": _vm.createOption,
      "data-test-id": _vm.dataTestIdString + "-multiselect",
      "classes": {
        option: 'normal-font p-2',
        optionSelected: 'bg-primary',
        optionPointed: 'bg-light',
        tag: 'multiselect-tag bg-gray-600',
        optionSelectedPointed: 'bg-primary',
        containerActive: 'focus',
        placeholder: 'multiselect-placeholder font-weight-light',
        singleLabelText: 'p-0 d-block mw-100 text-truncate',
        singleLabel: 'multiselect-single-label',
        optionDisabled: 'is-disabled text-gray-500'
      }
    },
    on: {
      "change": _vm.change,
      "search-change": _vm.handleSearchChange
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function (obj) {
        return [_c('li', [_c('p', {
          staticClass: "m-0 p-0"
        }, [_vm._v("\n        " + _vm._s(obj.option[_vm.displayProp]) + "\n        "), !obj.option[_vm.valueProp] && !!obj.option[_vm.displayProp] && _vm.allowAddnew ? _c('span', [_vm._v("\n          (" + _vm._s(_vm.$t('CommonButtons.AddNewLowercase')) + ")")]) : _vm._e()])])];
      }
    }]),
    model: {
      value: _vm.componentModelObject,
      callback: function ($$v) {
        _vm.componentModelObject = $$v;
      },
      expression: "componentModelObject"
    }
  });
};
var __vue_staticRenderFns__$6 = [];

/* style */
const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-1734badc_0", {
    source: ".focus[data-v-1734badc]:active{outline:1px solid var(--primary)}.focus[data-v-1734badc]:focus{outline:1px solid var(--primary)}.normal-font[data-v-1734badc]{font-size:var(--font-size-base)}.multiselect[data-v-1734badc]{min-height:2.1rem;line-height:1.5rem;border-radius:.25rem;border:1px solid var(--gray-400);--ms-placeholder-color:var(--dark)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$6 = "data-v-1734badc";
/* module identifier */
const __vue_module_identifier__$6 = undefined;
/* functional template */
const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

var script$5 = defineComponent({
  name: 'EventTaskSelect',
  components: {
    SearchSelect: __vue_component__$6
  },
  emits: ['taskSelection'],
  props: {
    reloadHistory: {
      type: Boolean,
      default: false
    },
    label: String,
    // optional overrides
    eventCode: String,
    baseUrl: String
  },
  setup(props, {
    emit
  }) {
    const hostnameParts = window.location.hostname.split('.');
    let {
      baseUrl
    } = props;
    if (!props.baseUrl) {
      baseUrl = "https://app.api.nx.lasso.io/app/v1";
      if (hostnameParts.includes('test')) {
        baseUrl = `https://app.api.nx.test.lasso.io/app/v1`;
      } else if (hostnameParts.includes('sandbox')) {
        baseUrl = "https://app.api.nx.sandbox.lasso.io/app/v1";
      } else if (hostnameParts.includes('local')) {
        baseUrl = "http://app.api.nx.local.lasso.io:9000/app/v1";
      }
    }
    const eventCode = ref(props.eventCode || null);
    const search = ref(undefined);
    // const selectedTask = ref(null);
    const myAxios = axios.create({
      baseURL: baseUrl,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const searchTasks = async searchStr => {
      if (!searchStr) return [];
      const {
        data
      } = await myAxios.post(`/events/${eventCode.value}/project/search_tasks`, {
        searchStr,
        taskListId: null
      });
      return data.rows;
    };
    const handleTaskSelect = async newValue => {
      search.value = newValue;
      if (newValue) {
        // selectedTask.value  = newValue;
        emit('taskSelection', newValue.id);
      }
    };
    watch(props, newProps => {
      if (newProps.reloadHistory) {
        search.value = undefined;
      }
    });
    onBeforeMount(async () => {
      if (!props.eventCode) {
        if (!window.location.pathname.match('/events/')) {
          return;
        }
        const pathParts = window.location.pathname.split('/');
        eventCode.value = pathParts[2];
      }
    });
    return {
      search,
      searchTasks,
      handleTaskSelect
    };
  }
});

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('b-form-group', {
    attrs: {
      "label": "Event Task",
      "label-for": "event_search"
    }
  }, [_c('SearchSelect', {
    attrs: {
      "id": "event_search",
      "modelValue": _vm.search,
      "options": _vm.searchTasks,
      "resolveOnLoad": true,
      "canClear": true,
      "clearOnSelect": true,
      "clearOnSearch": true,
      "valueProp": 'id',
      "displayProp": 'title',
      "required": false
    },
    on: {
      "update:modelValue": _vm.handleTaskSelect
    }
  })], 1);
};
var __vue_staticRenderFns__$5 = [];

/* style */
const __vue_inject_styles__$5 = undefined;
/* scoped */
const __vue_scope_id__$5 = undefined;
/* module identifier */
const __vue_module_identifier__$5 = undefined;
/* functional template */
const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

var script$4 = defineComponent({
  name: "EventProjectTimeEnter",
  components: {
    EventTaskSelect: __vue_component__$5
  },
  props: {
    reloadHistory: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object,
      default: () => ({
        timeInput: "Time",
        logTime: "Log Time",
        eventTask: "Event Task"
      })
    },
    // optional overrides
    eventCode: String,
    baseUrl: String
  },
  setup: props => {
    const bus = inject("bus");
    const hostnameParts = window.location.hostname.split('.');
    let {
      baseUrl
    } = props;
    if (!props.baseUrl) {
      baseUrl = "https://app.api.nx.lasso.io/app/v1";
      if (hostnameParts.includes('test')) {
        baseUrl = `https://app.api.nx.test.lasso.io/app/v1`;
      } else if (hostnameParts.includes('sandbox')) {
        baseUrl = "https://app.api.nx.sandbox.lasso.io/app/v1";
      } else if (hostnameParts.includes('local')) {
        baseUrl = "http://app.api.nx.local.lasso.io:9000/app/v1";
      }
    }
    const taskId = ref(null);
    const handleTaskSelection = id => {
      taskId.value = id;
    };
    const eventCode = ref(props.eventCode || null);
    const timeEntered = ref('');
    const myAxios = axios.create({
      baseURL: baseUrl,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const onLog = async () => {
      if (timeEntered.value === '') return;
      const [hrs, min] = timeEntered.value.split(":");
      const timeInSeconds = (hrs ? parseInt(hrs, 10) * 60 * 60 : 0) + (min ? parseInt(min, 10) * 60 : 0);
      await myAxios.post(`/events/${eventCode.value}/project/time`, {
        timeSpentInSeconds: timeInSeconds,
        taskId: taskId.value || null
      });
      // reset state of component
      timeEntered.value = '';
      bus.$emit('project-timer-msg', {
        msg: "logtime"
      });
    };
    watch(props, newProps => {
      if (newProps.reloadHistory) {
        timeEntered.value = '';
      }
    });
    onBeforeMount(async () => {
      if (!props.eventCode) {
        if (!window.location.pathname.match('/events/')) {
          return;
        }
        const pathParts = window.location.pathname.split('/');
        eventCode.value = pathParts[2];
      }
    });
    return {
      timeEntered,
      vMaska,
      onLog,
      handleTaskSelection
    };
  }
});

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "d-flex flex-column justify-content-center gap-4 mt-2"
  }, [_c('b-form', {
    staticClass: "d-flex flex-column justify-content-center gap-4 mt-2",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('EventTaskSelect', {
    attrs: {
      "label": _vm.labels.eventTask,
      "reloadHistory": _vm.reloadHistory
    },
    on: {
      "taskSelection": _vm.handleTaskSelection
    }
  }), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": _vm.labels.timeInput,
      "label-for": "time-input"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.timeEntered,
      expression: "timeEntered"
    }, {
      name: "maska",
      rawName: "v-maska"
    }],
    attrs: {
      "id": "time-input",
      "data-maska": "##:##",
      "data-maska-tokens": "#:[0-9]:optional",
      "placeholder": "hh:mm"
    },
    domProps: {
      "value": _vm.timeEntered
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.timeEntered = $event.target.value;
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "{margin-top": "6px",
      "padding": "2px",
      "color": "blue",
      "cursor": "grab"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onLog.apply(null, arguments);
      },
      "keydown": function ($event) {
        $event.preventDefault();
        return _vm.onLog.apply(null, arguments);
      }
    }
  }, [_c('b-icon-arrow-up', {
    attrs: {
      "disabled": _vm.timeEntered === '',
      "color": "blue"
    }
  }), _vm._v(" " + _vm._s(_vm.labels.logTime) + "\n  ")], 1)], 1);
};
var __vue_staticRenderFns__$4 = [];

/* style */
const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-1b094cde_0", {
    source: ".time[data-v-1b094cde]{font-size:20px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$4 = "data-v-1b094cde";
/* module identifier */
const __vue_module_identifier__$4 = undefined;
/* functional template */
const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

var script$3 = defineComponent({
  name: "EventProjectTimer",
  components: {
    EventTaskSelect: __vue_component__$5
  },
  props: {
    reloadHistory: {
      type: Boolean,
      default: false
    },
    eventTaskLabel: {
      type: String,
      default: "Event Task"
    },
    startLabel: {
      type: String,
      default: "START"
    },
    stopLabel: {
      type: String,
      default: "STOP"
    },
    // optional overrides
    eventCode: String,
    baseUrl: String
  },
  setup: props => {
    const bus = inject("bus");
    const taskId = ref(null);
    const handleTaskSelection = id => {
      taskId.value = id;
    };
    const hostnameParts = window.location.hostname.split('.');
    let {
      baseUrl
    } = props;
    if (!props.baseUrl) {
      baseUrl = "https://app.api.nx.lasso.io/app/v1";
      if (hostnameParts.includes('test')) {
        baseUrl = `https://app.api.nx.test.lasso.io/app/v1`;
      } else if (hostnameParts.includes('sandbox')) {
        baseUrl = "https://app.api.nx.sandbox.lasso.io/app/v1";
      } else if (hostnameParts.includes('local')) {
        baseUrl = "http://app.api.nx.local.lasso.io:9000/app/v1";
      }
    }
    const myAxios = axios.create({
      baseURL: baseUrl,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const timerRef = ref(null);
    const eventCode = ref(props.eventCode || null);
    const timerState = ref(undefined);
    const elapsedTime = ref(0);
    const getElapsedTime = startTime => {
      const endTime = new Date();
      let timeDiff = endTime.getTime() - startTime;
      timeDiff /= 1000;
      return timeDiff; // seconds...
    };

    const startClock = async () => {
      if (!timerState.value || timerState.value && !timerState.value.startTime) {
        const {
          data
        } = await myAxios.post(`/events/${eventCode.value}/project/start_timer`, {
          taskId: timerState.value && timerState.value.taskId || taskId.value
        });
        timerState.value = {
          ...data
        };
      }
      timerRef.value = setInterval(() => {
        elapsedTime.value = getElapsedTime(timerState.value.startTime);
      }, 1000);
      bus.$emit('project-timer-msg', {
        msg: 'startTimer'
      });
    };
    const stopClock = async () => {
      // /events/SDK-123123/project/stop_timer
      const {
        data
      } = await myAxios.post(`/events/${eventCode.value}/project/stop_timer`, {
        taskId: timerState.value && timerState.value.taskId || taskId.value,
        startTime: timerState.value.startTime
      });
      timerState.value = {
        ...data
      };
      if (timerRef.value) {
        clearInterval(timerRef.value);
        timerRef.value = null;
        elapsedTime.value = 0;
        timerState.value = null;
      }
      bus.$emit('project-timer-msg', {
        msg: 'stopTimer'
      });
    };
    const displayTime = computed(() => {
      let elapsed = elapsedTime.value;
      const seconds = Math.floor(elapsed % 60);
      const secondsAsString = seconds < 10 ? `0${seconds}` : `${seconds}`;
      elapsed = Math.floor(elapsed / 60);
      const minutes = elapsed % 60;
      const minutesAsString = minutes < 10 ? `0${minutes}` : `${minutes}`;
      elapsed = Math.floor(elapsed / 60);
      const hours = elapsed % 24;
      elapsed = Math.floor(elapsed / 24);
      const days = elapsed;
      const totalHours = hours + days * 24; // add days to hours
      const totalHoursAsString = totalHours < 10 ? `0${totalHours}` : `${totalHours}`;
      return `${totalHoursAsString}:${minutesAsString}:${secondsAsString}`;
    });
    onBeforeMount(async () => {
      if (!props.eventCode) {
        if (!window.location.pathname.match('/events/')) {
          return;
        }
        const pathParts = window.location.pathname.split('/');
        eventCode.value = pathParts[2];
      }
      const {
        data
      } = await myAxios.get(`/events/${eventCode.value}/project/timer_data`);
      if (data) {
        timerState.value = {
          ...data
        };
        if (data.startTime && !data.endTime) {
          elapsedTime.value = (Date.now() - data.startTime) / 1000;
          startClock();
        }
      }
    });
    return {
      startClock,
      stopClock,
      timerRef,
      displayTime,
      handleTaskSelection
    };
  }
});

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('b-form', {
    staticClass: "d-flex flex-column justify-content-center gap-4 mt-2"
  }, [_c('EventTaskSelect', {
    attrs: {
      "label": _vm.eventTaskLabel,
      "reloadHistory": _vm.reloadHistory
    },
    on: {
      "taskSelection": _vm.handleTaskSelection
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column justify-content-start align-items-center gap-4 p-2"
  }, [_c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.displayTime))]), _vm._v(" "), !_vm.timerRef ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "pill": "",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.startClock.apply(null, arguments);
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.startLabel) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.timerRef ? _c('b-button', {
    attrs: {
      "variant": "danger",
      "pill": "",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.stopClock.apply(null, arguments);
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.stopLabel) + "\n    ")]) : _vm._e()], 1)], 1);
};
var __vue_staticRenderFns__$3 = [];

/* style */
const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-ae4a4b74_0", {
    source: ".time[data-v-ae4a4b74]{font-size:20px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$3 = "data-v-ae4a4b74";
/* module identifier */
const __vue_module_identifier__$3 = undefined;
/* functional template */
const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

var script$2 = defineComponent({
  name: "EventProjectTimeHistory",
  props: {
    reloadHistory: {
      type: Boolean,
      default: false
    },
    formatDate: {
      type: Function,
      required: true
    },
    labels: Object,
    // optional overrides
    eventCode: String,
    baseUrl: String
  },
  setup: props => {
    const bus = inject("bus");
    const hostnameParts = window.location.hostname.split('.');
    let {
      baseUrl
    } = props;
    if (!props.baseUrl) {
      baseUrl = "https://app.api.nx.lasso.io/app/v1";
      if (hostnameParts.includes('test')) {
        baseUrl = `https://app.api.nx.test.lasso.io/app/v1`;
      } else if (hostnameParts.includes('sandbox')) {
        baseUrl = "https://app.api.nx.sandbox.lasso.io/app/v1";
      } else if (hostnameParts.includes('local')) {
        baseUrl = "http://app.api.nx.local.lasso.io:9000/app/v1";
      }
    }
    const myAxios = axios.create({
      baseURL: baseUrl,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const timeHistory = ref([]);
    const historyOpen = ref(false);
    const displayDate = dateStr => {
      const date = new Date(dateStr);
      return props.formatDate(date, 'LL/dd/yy');
    };
    const displayTime = seconds => {
      const zeroPad = num => String(num).padStart(2, '0');
      return `${zeroPad(Math.floor(seconds / 3600))}:${zeroPad(Math.floor(seconds / 60 % 60))}:${zeroPad(Math.floor(seconds % 60))}`;
    };
    const getProjectTimeHistory = async (page = 0, size = 25) => {
      const pathParts = window.location.pathname.split('/');
      const eventCode = pathParts[2];
      const resp = await myAxios.get(`/events/${eventCode}/project/time_history`, {
        data: {
          page,
          size
        }
      });
      const {
        data,
        status
      } = resp;
      const retData = {
        ...data,
        rows: data.rows,
        status
      };
      return retData;
    };
    const loadHistory = async () => {
      const resp = await getProjectTimeHistory();
      if (resp.status === 200) {
        timeHistory.value = resp.rows;
      }
    };
    onBeforeMount(() => {
      loadHistory();
    });
    watch(props, async newProps => {
      if (newProps.reloadHistory) {
        loadHistory();
        nextTick(() => {
          bus.$emit('project-timer-msg', {
            msg: "refreshHistoryDone"
          });
        });
      }
    });
    return {
      timeHistory,
      historyOpen,
      displayDate,
      displayTime
    };
  }
});

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', [_c('b-button', {
    staticClass: "accordion-btn",
    on: {
      "click": function ($event) {
        _vm.historyOpen = !_vm.historyOpen;
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.labels.buttonLabel))]), _vm._v(" "), !_vm.historyOpen ? _c('b-icon-caret-right-fill', {
    staticClass: "caret mr-2"
  }) : _c('b-icon-caret-down-fill', {
    staticClass: "caret mr-2"
  })], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2 overflow-auto",
    staticStyle: {
      "max-height": "550px"
    },
    attrs: {
      "id": "collapse-history"
    },
    model: {
      value: _vm.historyOpen,
      callback: function ($$v) {
        _vm.historyOpen = $$v;
      },
      expression: "historyOpen"
    }
  }, [_vm.timeHistory.length ? _c('div', {
    staticStyle: {
      "overflow": "scroll"
    }
  }, [_c('table', {
    attrs: {
      "id": "history-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.labels.eventColHeader))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labels.timeColHeader))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labels.dateColHeader))])])]), _vm._v(" "), _c('tbody', _vm._l(_vm.timeHistory, function (h) {
    return _c('tr', {
      key: h.id
    }, [_c('td', {
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden"
      }
    }, [_vm._v("\n              " + _vm._s(h.task ? h.task.title : h.event.name) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displayTime(h.timeSpentInSeconds || (h.endTime - h.startTime) / 1000)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displayDate(h.dbDateCreated)))])]);
  }), 0)])]) : _c('div', [_vm.timeHistory.length === 0 ? _c('div', [_vm._v(_vm._s(_vm.labels.noHistory))]) : _c('div', [_c('div', {
    staticClass: "w-100 align-items-center"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Loading"
    }
  })], 1)])])])], 1);
};
var __vue_staticRenderFns__$2 = [];

/* style */
const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-6557eb12_0", {
    source: ".caret[data-v-6557eb12]{float:right}.accordion-btn[data-v-6557eb12]{width:90%;margin:0 5px}#history-table[data-v-6557eb12]{table-layout:fixed;width:100%}#history-table thead>th[data-v-6557eb12]{font-weight:700}#history-table thead th[data-v-6557eb12]:nth-child(1){width:50%}#history-table td[data-v-6557eb12],#history-table th[data-v-6557eb12]{padding:2px;margin:1px}#history-table tbody td[data-v-6557eb12]{white-space:nowrap;overflow:hidden}.collapsed>.when-opened[data-v-6557eb12],:not(.collapsed)>.when-closed[data-v-6557eb12]{display:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$2 = "data-v-6557eb12";
/* module identifier */
const __vue_module_identifier__$2 = undefined;
/* functional template */
const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

//
var script$1 = defineComponent({
  name: 'ProjectTimerNavItem',
  components: {
    EventProjectTimeEnter: __vue_component__$4,
    EventProjectTimer: __vue_component__$3,
    EventProjectTimeHistory: __vue_component__$2
  },
  props: {
    timerRunning: {
      type: Boolean,
      default: false
    },
    reloadHistory: {
      type: Boolean,
      default: false
    },
    formatDate: {
      type: Function,
      required: true
    },
    labels: {
      type: Object,
      required: true
    },
    eventCode: {
      type: String,
      required: false
    },
    baseUrl: {
      type: String,
      required: false
    }
  },
  setup() {
    const tabIndex = ref(0);
    const handleTabChange = newTabIdx => {
      tabIndex.value = newTabIdx;
    };
    return {
      handleTabChange
    };
  }
});

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.project-timer-sidebar",
      modifiers: {
        "project-timer-sidebar": true
      }
    }],
    staticClass: "timer-btn",
    attrs: {
      "variant": "link",
      "data-test-id": "project-timer-toggle"
    }
  }, [_c('b-icon', {
    attrs: {
      "variant": "primary",
      "icon": "stopwatch-fill"
    }
  })], 1), _vm._v(" "), _c('b-sidebar', {
    attrs: {
      "id": "project-timer-sidebar",
      "sidebar-class": "floating-sidebar",
      "no-header": "",
      "right": "",
      "backdrop": "",
      "backdrop-variant": "transparent"
    }
  }, [_c('b-card', {
    staticClass: "rounded-3"
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.project-timer-sidebar",
      modifiers: {
        "project-timer-sidebar": true
      }
    }],
    staticClass: "bg-white border-0 shadow-none p-0 pb-2",
    attrs: {
      "id": "hide-notifications",
      "variant": "light"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x"
    }
  })], 1), _vm._v(" "), _c('b-card', {
    staticClass: "panel-tabs"
  }, [_c('b-tabs', {
    on: {
      "activate-tab": _vm.handleTabChange
    }
  }, [_c('b-tab', {
    ref: "timeEnterTab",
    attrs: {
      "title": _vm.labels.tab1Title,
      "disabled": _vm.timerRunning
    }
  }, [_c('EventProjectTimeEnter', {
    attrs: {
      "labels": _vm.labels,
      "reloadHistory": _vm.reloadHistory,
      "eventCode": _vm.eventCode,
      "baseUrl": _vm.baseUrl
    }
  })], 1), _vm._v(" "), _c('b-tab', {
    ref: "timerTab",
    attrs: {
      "title": _vm.labels.tab2Title,
      "lazy": ""
    }
  }, [_c('EventProjectTimer', {
    attrs: {
      "eventTaskLabel": _vm.labels.eventTaskLabel,
      "startLabel": _vm.labels.startLabel,
      "stopLabel": _vm.labels.stopLabel,
      "reloadHistory": _vm.reloadHistory,
      "eventCode": _vm.eventCode,
      "baseUrl": _vm.baseUrl
    }
  })], 1)], 1), _vm._v(" "), _c('EventProjectTimeHistory', {
    attrs: {
      "reloadHistory": _vm.reloadHistory,
      "formatDate": _vm.formatDate,
      "labels": _vm.labels,
      "eventCode": _vm.eventCode,
      "baseUrl": _vm.baseUrl
    }
  })], 1)], 1)], 1)], 1);
};
var __vue_staticRenderFns__$1 = [];

/* style */
const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-6e11ed83_0", {
    source: ".timer-btn[data-v-6e11ed83]{background-color:#1f1f1f;font-size:1.1rem;padding:.3rem}[data-v-6e11ed83] .b-sidebar.floating-sidebar{background:0 0;right:2rem;top:50px;height:auto;max-height:calc(100vh - 50px)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$1 = "data-v-6e11ed83";
/* module identifier */
const __vue_module_identifier__$1 = undefined;
/* functional template */
const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

var script = defineComponent({
  name: 'NotificationsNavItem',
  setup() {
    return {
      unreadUserNotificationCount: 0
    };
  }
});

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.project-notification-sidebar",
      modifiers: {
        "project-notification-sidebar": true
      }
    }],
    staticClass: "notification-btn",
    attrs: {
      "variant": "link",
      "data-test-id": "project-timer-toggle"
    }
  }, [_c('b-icon', {
    attrs: {
      "variant": "primary",
      "icon": "bell-fill"
    }
  }), _vm._v(" "), _vm.unreadUserNotificationCount ? _c('span', {
    class: {
      'bg-danger text-white': true,
      'unread-count-single-int': _vm.unreadUserNotificationCount < 10,
      'unread-count-double-int': _vm.unreadUserNotificationCount >= 10 && _vm.unreadUserNotificationCount <= 99,
      'unread-count-triple-int': _vm.unreadUserNotificationCount > 99
    },
    attrs: {
      "id": "unread-notifications-count"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.unreadUserNotificationCount > 99 ? '99+' : _vm.unreadUserNotificationCount) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('b-sidebar', {
    attrs: {
      "id": "project-notification-sidebar",
      "sidebar-class": "floating-sidebar",
      "no-header": "",
      "right": "",
      "backdrop": "",
      "backdrop-variant": "transparent"
    }
  }, [_c('b-card')], 1)], 1);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-18db8420_0", {
    source: ".notification-btn[data-v-18db8420]{background-color:#1f1f1f;font-size:1.1rem;padding:.3rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-18db8420";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LIconLassoLogo: __vue_component__$z,
  LIconMarketplace: __vue_component__$y,
  LIconSmartCrew: __vue_component__$x,
  LIconAirplane: __vue_component__$w,
  LIconAirplaneBegin: __vue_component__$v,
  LIconAirplaneEnd: __vue_component__$u,
  LIconClipboardCheck: __vue_component__$t,
  LIconCommunicate: __vue_component__$s,
  LIconCrewNote: __vue_component__$r,
  LIconEvent: __vue_component__$q,
  LIconGroup: __vue_component__$p,
  LIconHistory: __vue_component__$o,
  LIconMoreMenu: __vue_component__$n,
  LIconPencilFill: __vue_component__$m,
  LIconPeople: __vue_component__$l,
  LIconPlatform: __vue_component__$k,
  LIconPositionNote: __vue_component__$j,
  LIconRates: __vue_component__$i,
  LIconReceipt: __vue_component__$h,
  LIconSpeaker: __vue_component__$g,
  LIconStats: __vue_component__$f,
  LIconSupervisors: __vue_component__$e,
  LIconVenue: __vue_component__$d,
  LIconWallet: __vue_component__$c,
  LIconWarehouse: __vue_component__$b,
  LToast: __vue_component__$a,
  LUserPreferencesSidebar: __vue_component__$9,
  LUserPreferencesDropdownItem: __vue_component__$8,
  LProjectTimerNav: __vue_component__$1,
  LNotificationsNav: __vue_component__
});

// Import vue components
// install function executed by Vue.use()
const install = function installLassoVueStyles(Vue) {
  Object.entries(components).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
};

export { IconSizes, __vue_component__$w as LIconAirplane, __vue_component__$v as LIconAirplaneBegin, __vue_component__$u as LIconAirplaneEnd, __vue_component__$t as LIconClipboardCheck, __vue_component__$s as LIconCommunicate, __vue_component__$r as LIconCrewNote, __vue_component__$q as LIconEvent, __vue_component__$p as LIconGroup, __vue_component__$o as LIconHistory, __vue_component__$z as LIconLassoLogo, __vue_component__$y as LIconMarketplace, __vue_component__$n as LIconMoreMenu, __vue_component__$m as LIconPencilFill, __vue_component__$l as LIconPeople, __vue_component__$k as LIconPlatform, __vue_component__$j as LIconPositionNote, __vue_component__$i as LIconRates, __vue_component__$h as LIconReceipt, __vue_component__$x as LIconSmartCrew, __vue_component__$g as LIconSpeaker, __vue_component__$f as LIconStats, __vue_component__$e as LIconSupervisors, __vue_component__$d as LIconVenue, __vue_component__$c as LIconWallet, __vue_component__$b as LIconWarehouse, __vue_component__ as LNotificationsNav, __vue_component__$1 as LProjectTimerNav, __vue_component__$a as LToast, __vue_component__$8 as LUserPreferencesDropdownItem, __vue_component__$9 as LUserPreferencesSidebar, LassoIconSizes, install as default };
